// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
      "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-red-900: oklch(39.6% 0.141 25.723);
    --color-red-950: oklch(25.8% 0.092 26.042);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-orange-600: oklch(64.6% 0.222 41.116);
    --color-orange-700: oklch(55.3% 0.195 38.402);
    --color-orange-800: oklch(47% 0.157 37.304);
    --color-orange-900: oklch(40.8% 0.123 38.172);
    --color-amber-100: oklch(96.2% 0.059 95.617);
    --color-amber-200: oklch(92.4% 0.12 95.746);
    --color-amber-300: oklch(87.9% 0.169 91.605);
    --color-amber-400: oklch(82.8% 0.189 84.429);
    --color-amber-500: oklch(76.9% 0.188 70.08);
    --color-amber-600: oklch(66.6% 0.179 58.318);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-800: oklch(47.3% 0.137 46.201);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-yellow-50: oklch(98.7% 0.026 102.212);
    --color-yellow-100: oklch(97.3% 0.071 103.193);
    --color-yellow-300: oklch(90.5% 0.182 98.111);
    --color-yellow-400: oklch(85.2% 0.199 91.936);
    --color-yellow-500: oklch(79.5% 0.184 86.047);
    --color-yellow-600: oklch(68.1% 0.162 75.834);
    --color-yellow-700: oklch(55.4% 0.135 66.442);
    --color-yellow-800: oklch(47.6% 0.114 61.907);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-300: oklch(87.1% 0.15 154.449);
    --color-green-400: oklch(79.2% 0.209 151.711);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-green-900: oklch(39.3% 0.095 152.535);
    --color-emerald-300: oklch(84.5% 0.143 164.978);
    --color-emerald-400: oklch(76.5% 0.177 163.223);
    --color-emerald-500: oklch(69.6% 0.17 162.48);
    --color-emerald-600: oklch(59.6% 0.145 163.225);
    --color-emerald-700: oklch(50.8% 0.118 165.612);
    --color-teal-500: oklch(70.4% 0.14 182.503);
    --color-teal-600: oklch(60% 0.118 184.704);
    --color-teal-700: oklch(51.1% 0.096 186.391);
    --color-cyan-200: oklch(91.7% 0.08 205.041);
    --color-cyan-300: oklch(86.5% 0.127 207.078);
    --color-cyan-400: oklch(78.9% 0.154 211.53);
    --color-cyan-500: oklch(71.5% 0.143 215.221);
    --color-cyan-700: oklch(52% 0.105 223.128);
    --color-cyan-900: oklch(39.8% 0.07 227.392);
    --color-sky-600: oklch(58.8% 0.158 241.966);
    --color-sky-700: oklch(50% 0.134 242.749);
    --color-blue-100: oklch(93.2% 0.032 255.585);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-300: oklch(80.9% 0.105 251.813);
    --color-blue-400: oklch(70.7% 0.165 254.624);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-800: oklch(42.4% 0.199 265.638);
    --color-blue-900: oklch(37.9% 0.146 265.522);
    --color-indigo-300: oklch(78.5% 0.115 274.713);
    --color-indigo-500: oklch(58.5% 0.233 277.117);
    --color-indigo-700: oklch(45.7% 0.24 277.023);
    --color-indigo-900: oklch(35.9% 0.144 278.697);
    --color-purple-300: oklch(82.7% 0.119 306.383);
    --color-purple-400: oklch(71.4% 0.203 305.504);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-purple-600: oklch(55.8% 0.288 302.321);
    --color-purple-700: oklch(49.6% 0.265 301.924);
    --color-purple-900: oklch(38.1% 0.176 304.987);
    --color-fuchsia-400: oklch(74% 0.238 322.16);
    --color-pink-300: oklch(82.3% 0.12 346.018);
    --color-pink-400: oklch(71.8% 0.202 349.761);
    --color-pink-500: oklch(65.6% 0.241 354.308);
    --color-pink-600: oklch(59.2% 0.249 0.584);
    --color-pink-700: oklch(52.5% 0.223 3.958);
    --color-rose-600: oklch(58.6% 0.253 17.585);
    --color-rose-700: oklch(51.4% 0.222 16.935);
    --color-slate-100: oklch(96.8% 0.007 247.896);
    --color-slate-200: oklch(92.9% 0.013 255.508);
    --color-slate-300: oklch(86.9% 0.022 252.894);
    --color-slate-400: oklch(70.4% 0.04 256.788);
    --color-slate-500: oklch(55.4% 0.046 257.417);
    --color-slate-600: oklch(44.6% 0.043 257.281);
    --color-slate-700: oklch(37.2% 0.044 257.287);
    --color-slate-800: oklch(27.9% 0.041 260.031);
    --color-slate-900: oklch(20.8% 0.042 265.755);
    --color-slate-950: oklch(12.9% 0.042 264.695);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --text-7xl: 4.5rem;
    --text-7xl--line-height: 1;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-relaxed: 1.625;
    --radius-xs: 0.125rem;
    --radius-2xl: 1rem;
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-sm: 8px;
    --blur-3xl: 64px;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-border: var(--border);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring:where(:not(iframe)) {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container\\/card-header {
    container-type: inline-size;
    container-name: card-header;
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: 0px;
  }
  .inset-x-0 {
    inset-inline: 0px;
  }
  .inset-y-0 {
    inset-block: 0px;
  }
  .-top-1 {
    top: calc(var(--spacing) * -1);
  }
  .-top-5 {
    top: calc(var(--spacing) * -5);
  }
  .-top-6 {
    top: calc(var(--spacing) * -6);
  }
  .-top-12 {
    top: calc(var(--spacing) * -12);
  }
  .top-0 {
    top: 0px;
  }
  .top-1 {
    top: var(--spacing);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-3\\.5 {
    top: calc(var(--spacing) * 3.5);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .top-\\[1px\\] {
    top: 1px;
  }
  .top-\\[50\\%\\] {
    top: 50%;
  }
  .top-\\[60\\%\\] {
    top: 60%;
  }
  .top-full {
    top: 100%;
  }
  .-right-12 {
    right: calc(var(--spacing) * -12);
  }
  .right-0 {
    right: 0px;
  }
  .right-1 {
    right: var(--spacing);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .-bottom-12 {
    bottom: calc(var(--spacing) * -12);
  }
  .bottom-0 {
    bottom: 0px;
  }
  .bottom-1 {
    bottom: var(--spacing);
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2);
  }
  .bottom-full {
    bottom: 100%;
  }
  .-left-4 {
    left: calc(var(--spacing) * -4);
  }
  .-left-12 {
    left: calc(var(--spacing) * -12);
  }
  .left-0 {
    left: 0px;
  }
  .left-1 {
    left: var(--spacing);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .left-3 {
    left: calc(var(--spacing) * 3);
  }
  .left-\\[50\\%\\] {
    left: 50%;
  }
  .isolate {
    isolation: isolate;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[1\\] {
    z-index: 1;
  }
  .z-\\[60\\] {
    z-index: 60;
  }
  .z-\\[100\\] {
    z-index: 100;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-full {
    grid-column: 1 / -1;
  }
  .col-start-2 {
    grid-column-start: 2;
  }
  .row-span-2 {
    grid-row: span 2 / span 2;
  }
  .row-start-1 {
    grid-row-start: 1;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .-m-0\\.5 {
    margin: calc(var(--spacing) * -0.5);
  }
  .-mx-1 {
    margin-inline: calc(var(--spacing) * -1);
  }
  .-mx-2 {
    margin-inline: calc(var(--spacing) * -2);
  }
  .-mx-3 {
    margin-inline: calc(var(--spacing) * -3);
  }
  .-mx-5 {
    margin-inline: calc(var(--spacing) * -5);
  }
  .mx-1 {
    margin-inline: var(--spacing);
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-3\\.5 {
    margin-inline: calc(var(--spacing) * 3.5);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-5 {
    margin-inline: calc(var(--spacing) * 5);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-0\\.5 {
    margin-block: calc(var(--spacing) * 0.5);
  }
  .my-1 {
    margin-block: var(--spacing);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .-mt-4 {
    margin-top: calc(var(--spacing) * -4);
  }
  .mt-0 {
    margin-top: 0px;
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: var(--spacing);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-auto {
    margin-top: auto;
  }
  .mr-1 {
    margin-right: var(--spacing);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-3 {
    margin-right: calc(var(--spacing) * 3);
  }
  .mr-4 {
    margin-right: calc(var(--spacing) * 4);
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: var(--spacing);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-16 {
    margin-bottom: calc(var(--spacing) * 16);
  }
  .-ml-4 {
    margin-left: calc(var(--spacing) * -4);
  }
  .ml-1 {
    margin-left: var(--spacing);
  }
  .ml-1\\.5 {
    margin-left: calc(var(--spacing) * 1.5);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-3 {
    margin-left: calc(var(--spacing) * 3);
  }
  .ml-auto {
    margin-left: auto;
  }
  .line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .table-caption {
    display: table-caption;
  }
  .table-cell {
    display: table-cell;
  }
  .table-row {
    display: table-row;
  }
  .field-sizing-content {
    field-sizing: content;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .aspect-video {
    aspect-ratio: var(--aspect-video);
  }
  .size-\\(--cell-size\\) {
    width: var(--cell-size);
    height: var(--cell-size);
  }
  .size-2 {
    width: calc(var(--spacing) * 2);
    height: calc(var(--spacing) * 2);
  }
  .size-2\\.5 {
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }
  .size-3 {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
  }
  .size-3\\.5 {
    width: calc(var(--spacing) * 3.5);
    height: calc(var(--spacing) * 3.5);
  }
  .size-4 {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .size-7 {
    width: calc(var(--spacing) * 7);
    height: calc(var(--spacing) * 7);
  }
  .size-8 {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .size-9 {
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
  }
  .size-auto {
    width: auto;
    height: auto;
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .\\!h-\\[95vh\\] {
    height: 95vh !important;
  }
  .h-\\(--cell-size\\) {
    height: var(--cell-size);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-96 {
    height: calc(var(--spacing) * 96);
  }
  .h-\\[1\\.15rem\\] {
    height: 1.15rem;
  }
  .h-\\[18px\\] {
    height: 18px;
  }
  .h-\\[300px\\] {
    height: 300px;
  }
  .h-\\[calc\\(100\\%-1px\\)\\] {
    height: calc(100% - 1px);
  }
  .h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
    height: var(--radix-navigation-menu-viewport-height);
  }
  .h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height);
  }
  .h-auto {
    height: auto;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .h-svh {
    height: 100svh;
  }
  .\\!max-h-\\[95vh\\] {
    max-height: 95vh !important;
  }
  .max-h-\\(--radix-context-menu-content-available-height\\) {
    max-height: var(--radix-context-menu-content-available-height);
  }
  .max-h-\\(--radix-dropdown-menu-content-available-height\\) {
    max-height: var(--radix-dropdown-menu-content-available-height);
  }
  .max-h-\\(--radix-select-content-available-height\\) {
    max-height: var(--radix-select-content-available-height);
  }
  .max-h-32 {
    max-height: calc(var(--spacing) * 32);
  }
  .max-h-40 {
    max-height: calc(var(--spacing) * 40);
  }
  .max-h-48 {
    max-height: calc(var(--spacing) * 48);
  }
  .max-h-\\[40vh\\] {
    max-height: 40vh;
  }
  .max-h-\\[44vh\\] {
    max-height: 44vh;
  }
  .max-h-\\[50vh\\] {
    max-height: 50vh;
  }
  .max-h-\\[60vh\\] {
    max-height: 60vh;
  }
  .max-h-\\[80vh\\] {
    max-height: 80vh;
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh;
  }
  .max-h-\\[94vh\\] {
    max-height: 94vh;
  }
  .max-h-\\[95vh\\] {
    max-height: 95vh;
  }
  .max-h-\\[118px\\] {
    max-height: 118px;
  }
  .max-h-\\[120px\\] {
    max-height: 120px;
  }
  .max-h-\\[180px\\] {
    max-height: 180px;
  }
  .max-h-\\[250px\\] {
    max-height: 250px;
  }
  .max-h-\\[300px\\] {
    max-height: 300px;
  }
  .max-h-\\[320px\\] {
    max-height: 320px;
  }
  .max-h-\\[360px\\] {
    max-height: 360px;
  }
  .max-h-\\[500px\\] {
    max-height: 500px;
  }
  .max-h-\\[520px\\] {
    max-height: 520px;
  }
  .max-h-\\[720px\\] {
    max-height: 720px;
  }
  .max-h-\\[calc\\(100dvh-2rem\\)\\] {
    max-height: calc(100dvh - 2rem);
  }
  .max-h-screen {
    max-height: 100vh;
  }
  .min-h-0 {
    min-height: 0px;
  }
  .min-h-4 {
    min-height: calc(var(--spacing) * 4);
  }
  .min-h-16 {
    min-height: calc(var(--spacing) * 16);
  }
  .min-h-\\[2\\.5rem\\] {
    min-height: 2.5rem;
  }
  .min-h-\\[260px\\] {
    min-height: 260px;
  }
  .min-h-\\[300px\\] {
    min-height: 300px;
  }
  .min-h-\\[520px\\] {
    min-height: 520px;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .min-h-svh {
    min-height: 100svh;
  }
  .\\!w-\\[95vw\\] {
    width: 95vw !important;
  }
  .w-\\(--cell-size\\) {
    width: var(--cell-size);
  }
  .w-\\(--sidebar-width\\) {
    width: var(--sidebar-width);
  }
  .w-0 {
    width: 0px;
  }
  .w-1 {
    width: var(--spacing);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-3\\/4 {
    width: calc(3 / 4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-44 {
    width: calc(var(--spacing) * 44);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-\\[3px\\] {
    width: 3px;
  }
  .w-\\[18px\\] {
    width: 18px;
  }
  .w-\\[82px\\] {
    width: 82px;
  }
  .w-\\[100px\\] {
    width: 100px;
  }
  .w-\\[110px\\] {
    width: 110px;
  }
  .w-\\[130px\\] {
    width: 130px;
  }
  .w-\\[140px\\] {
    width: 140px;
  }
  .w-\\[160px\\] {
    width: 160px;
  }
  .w-\\[180px\\] {
    width: 180px;
  }
  .w-auto {
    width: auto;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-max {
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .\\!max-w-\\[95vw\\] {
    max-width: 95vw !important;
  }
  .max-w-\\(--skeleton-width\\) {
    max-width: var(--skeleton-width);
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-6xl {
    max-width: var(--container-6xl);
  }
  .max-w-7xl {
    max-width: var(--container-7xl);
  }
  .max-w-\\[80mm\\] {
    max-width: 80mm;
  }
  .max-w-\\[120px\\] {
    max-width: 120px;
  }
  .max-w-\\[160px\\] {
    max-width: 160px;
  }
  .max-w-\\[200px\\] {
    max-width: 200px;
  }
  .max-w-\\[500px\\] {
    max-width: 500px;
  }
  .max-w-\\[520px\\] {
    max-width: 520px;
  }
  .max-w-\\[560px\\] {
    max-width: 560px;
  }
  .max-w-\\[620px\\] {
    max-width: 620px;
  }
  .max-w-\\[640px\\] {
    max-width: 640px;
  }
  .max-w-\\[900px\\] {
    max-width: 900px;
  }
  .max-w-\\[1180px\\] {
    max-width: 1180px;
  }
  .max-w-\\[1800px\\] {
    max-width: 1800px;
  }
  .max-w-\\[1900px\\] {
    max-width: 1900px;
  }
  .max-w-\\[calc\\(100\\%-2rem\\)\\] {
    max-width: calc(100% - 2rem);
  }
  .max-w-\\[calc\\(100vw-2rem\\)\\] {
    max-width: calc(100vw - 2rem);
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-max {
    max-width: max-content;
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .min-w-\\(--cell-size\\) {
    min-width: var(--cell-size);
  }
  .min-w-0 {
    min-width: 0px;
  }
  .min-w-5 {
    min-width: calc(var(--spacing) * 5);
  }
  .min-w-6 {
    min-width: calc(var(--spacing) * 6);
  }
  .min-w-8 {
    min-width: calc(var(--spacing) * 8);
  }
  .min-w-9 {
    min-width: calc(var(--spacing) * 9);
  }
  .min-w-10 {
    min-width: calc(var(--spacing) * 10);
  }
  .min-w-\\[3\\.5rem\\] {
    min-width: 3.5rem;
  }
  .min-w-\\[7\\.5rem\\] {
    min-width: 7.5rem;
  }
  .min-w-\\[8rem\\] {
    min-width: 8rem;
  }
  .min-w-\\[9rem\\] {
    min-width: 9rem;
  }
  .min-w-\\[12rem\\] {
    min-width: 12rem;
  }
  .min-w-\\[76px\\] {
    min-width: 76px;
  }
  .min-w-\\[80px\\] {
    min-width: 80px;
  }
  .min-w-\\[90px\\] {
    min-width: 90px;
  }
  .min-w-\\[120px\\] {
    min-width: 120px;
  }
  .min-w-\\[140px\\] {
    min-width: 140px;
  }
  .min-w-\\[180px\\] {
    min-width: 180px;
  }
  .min-w-\\[700px\\] {
    min-width: 700px;
  }
  .min-w-\\[760px\\] {
    min-width: 760px;
  }
  .min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width);
  }
  .min-w-full {
    min-width: 100%;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .grow-0 {
    flex-grow: 0;
  }
  .basis-full {
    flex-basis: 100%;
  }
  .caption-bottom {
    caption-side: bottom;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .origin-\\(--radix-context-menu-content-transform-origin\\) {
    transform-origin: var(--radix-context-menu-content-transform-origin);
  }
  .origin-\\(--radix-dropdown-menu-content-transform-origin\\) {
    transform-origin: var(--radix-dropdown-menu-content-transform-origin);
  }
  .origin-\\(--radix-hover-card-content-transform-origin\\) {
    transform-origin: var(--radix-hover-card-content-transform-origin);
  }
  .origin-\\(--radix-menubar-content-transform-origin\\) {
    transform-origin: var(--radix-menubar-content-transform-origin);
  }
  .origin-\\(--radix-popover-content-transform-origin\\) {
    transform-origin: var(--radix-popover-content-transform-origin);
  }
  .origin-\\(--radix-select-content-transform-origin\\) {
    transform-origin: var(--radix-select-content-transform-origin);
  }
  .origin-\\(--radix-tooltip-content-transform-origin\\) {
    transform-origin: var(--radix-tooltip-content-transform-origin);
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-px {
    --tw-translate-x: -1px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-px {
    --tw-translate-x: 1px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-0\\.5 {
    --tw-translate-y: calc(var(--spacing) * 0.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[calc\\(-50\\%_-_2px\\)\\] {
    --tw-translate-y: calc(-50% - 2px);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .rotate-45 {
    rotate: 45deg;
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-caret-blink {
    animation: caret-blink 1.25s ease-out infinite;
  }
  .animate-in {
    animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .touch-none {
    touch-action: none;
  }
  .resize-none {
    resize: none;
  }
  .snap-x {
    scroll-snap-type: x var(--tw-scroll-snap-strictness);
  }
  .snap-mandatory {
    --tw-scroll-snap-strictness: mandatory;
  }
  .snap-center {
    scroll-snap-align: center;
  }
  .scroll-my-1 {
    scroll-margin-block: var(--spacing);
  }
  .scroll-py-1 {
    scroll-padding-block: var(--spacing);
  }
  .scrollbar-thin {
    scrollbar-width: thin;
  }
  .list-inside {
    list-style-position: inside;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .auto-rows-min {
    grid-auto-rows: min-content;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-\\[0_1fr\\] {
    grid-template-columns: 0 1fr;
  }
  .grid-cols-\\[1\\.4fr_1fr_0\\.8fr_0\\.9fr_1fr_0\\.7fr\\] {
    grid-template-columns: 1.4fr 1fr 0.8fr 0.9fr 1fr 0.7fr;
  }
  .grid-rows-\\[auto_auto\\] {
    grid-template-rows: auto auto;
  }
  .grid-rows-\\[minmax\\(0\\,2fr\\)_minmax\\(0\\,3fr\\)\\] {
    grid-template-rows: minmax(0,2fr) minmax(0,3fr);
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-stretch {
    align-items: stretch;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-items-start {
    justify-items: start;
  }
  .gap-0 {
    gap: 0px;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: var(--spacing);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-16 {
    gap: calc(var(--spacing) * 16);
  }
  :where(.space-y-0 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: 0;
    margin-block-end: 0;
  }
  :where(.space-y-0\\.5 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-1 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(var(--spacing) * var(--tw-space-y-reverse));
    margin-block-end: calc(var(--spacing) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-1\\.5 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-2 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-3 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-4 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-5 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-6 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-8 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-x-6 {
    column-gap: calc(var(--spacing) * 6);
  }
  :where(.space-x-1 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(var(--spacing) * var(--tw-space-x-reverse));
    margin-inline-end: calc(var(--spacing) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-2 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-4 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
  }
  .gap-y-0\\.5 {
    row-gap: calc(var(--spacing) * 0.5);
  }
  .gap-y-1 {
    row-gap: var(--spacing);
  }
  .gap-y-1\\.5 {
    row-gap: calc(var(--spacing) * 1.5);
  }
  :where(.divide-y > :not(:last-child)) {
    --tw-divide-y-reverse: 0;
    border-bottom-style: var(--tw-border-style);
    border-top-style: var(--tw-border-style);
    border-top-width: calc(1px * var(--tw-divide-y-reverse));
    border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  }
  :where(.divide-slate-700\\/50 > :not(:last-child)) {
    border-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-700) 50%, transparent);
    }
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .justify-self-end {
    justify-self: flex-end;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .scroll-smooth {
    scroll-behavior: smooth;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-\\[2px\\] {
    border-radius: 2px;
  }
  .rounded-\\[4px\\] {
    border-radius: 4px;
  }
  .rounded-\\[inherit\\] {
    border-radius: inherit;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius);
  }
  .rounded-md {
    border-radius: calc(var(--radius) - 2px);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-sm {
    border-radius: calc(var(--radius) - 4px);
  }
  .rounded-xl {
    border-radius: calc(var(--radius) + 4px);
  }
  .rounded-xs {
    border-radius: var(--radius-xs);
  }
  .rounded-l-lg {
    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
  }
  .rounded-l-md {
    border-top-left-radius: calc(var(--radius) - 2px);
    border-bottom-left-radius: calc(var(--radius) - 2px);
  }
  .rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rounded-tl-sm {
    border-top-left-radius: calc(var(--radius) - 4px);
  }
  .rounded-r-md {
    border-top-right-radius: calc(var(--radius) - 2px);
    border-bottom-right-radius: calc(var(--radius) - 2px);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-4 {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .border-\\[1\\.5px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.5px;
  }
  .border-y {
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-2 {
    border-top-style: var(--tw-border-style);
    border-top-width: 2px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-l-4 {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-dotted {
    --tw-border-style: dotted;
    border-style: dotted;
  }
  .border-\\(--color-border\\) {
    border-color: var(--color-border);
  }
  .border-\\[color\\:var\\(--mc-amber\\)\\] {
    border-color: var(--mc-amber);
  }
  .border-\\[color\\:var\\(--mc-cyan\\)\\] {
    border-color: var(--mc-cyan);
  }
  .border-\\[color\\:var\\(--mc-divider\\)\\] {
    border-color: var(--mc-divider);
  }
  .border-\\[color\\:var\\(--mc-divider-soft\\)\\] {
    border-color: var(--mc-divider-soft);
  }
  .border-\\[rgba\\(95\\,214\\,146\\,0\\.35\\)\\] {
    border-color: rgba(95,214,146,0.35);
  }
  .border-\\[rgba\\(95\\,214\\,146\\,0\\.45\\)\\] {
    border-color: rgba(95,214,146,0.45);
  }
  .border-\\[rgba\\(184\\,85\\,231\\,0\\.35\\)\\] {
    border-color: rgba(184,85,231,0.35);
  }
  .border-\\[rgba\\(244\\,122\\,165\\,0\\.35\\)\\] {
    border-color: rgba(244,122,165,0.35);
  }
  .border-\\[rgba\\(244\\,122\\,165\\,0\\.42\\)\\] {
    border-color: rgba(244,122,165,0.42);
  }
  .border-\\[rgba\\(248\\,199\\,88\\,0\\.35\\)\\] {
    border-color: rgba(248,199,88,0.35);
  }
  .border-amber-400\\/60 {
    border-color: color-mix(in srgb, oklch(82.8% 0.189 84.429) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-amber-400) 60%, transparent);
    }
  }
  .border-amber-500 {
    border-color: var(--color-amber-500);
  }
  .border-amber-500\\/30 {
    border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-amber-500) 30%, transparent);
    }
  }
  .border-amber-500\\/40 {
    border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-amber-500) 40%, transparent);
    }
  }
  .border-amber-500\\/50 {
    border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-amber-500) 50%, transparent);
    }
  }
  .border-amber-500\\/70 {
    border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-amber-500) 70%, transparent);
    }
  }
  .border-amber-600 {
    border-color: var(--color-amber-600);
  }
  .border-amber-700 {
    border-color: var(--color-amber-700);
  }
  .border-black {
    border-color: var(--color-black);
  }
  .border-blue-400\\/40 {
    border-color: color-mix(in srgb, oklch(70.7% 0.165 254.624) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-blue-400) 40%, transparent);
    }
  }
  .border-blue-500\\/30 {
    border-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-blue-500) 30%, transparent);
    }
  }
  .border-blue-500\\/50 {
    border-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-blue-500) 50%, transparent);
    }
  }
  .border-blue-700 {
    border-color: var(--color-blue-700);
  }
  .border-border\\/50 {
    border-color: var(--border);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--border) 50%, transparent);
    }
  }
  .border-cyan-700 {
    border-color: var(--color-cyan-700);
  }
  .border-destructive {
    border-color: var(--destructive);
  }
  .border-emerald-400\\/30 {
    border-color: color-mix(in srgb, oklch(76.5% 0.177 163.223) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-emerald-400) 30%, transparent);
    }
  }
  .border-emerald-400\\/40 {
    border-color: color-mix(in srgb, oklch(76.5% 0.177 163.223) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-emerald-400) 40%, transparent);
    }
  }
  .border-emerald-500 {
    border-color: var(--color-emerald-500);
  }
  .border-emerald-500\\/20 {
    border-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-emerald-500) 20%, transparent);
    }
  }
  .border-emerald-500\\/30 {
    border-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-emerald-500) 30%, transparent);
    }
  }
  .border-emerald-500\\/50 {
    border-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-emerald-500) 50%, transparent);
    }
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-gray-500\\/30 {
    border-color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-gray-500) 30%, transparent);
    }
  }
  .border-gray-700 {
    border-color: var(--color-gray-700);
  }
  .border-green-400\\/50 {
    border-color: color-mix(in srgb, oklch(79.2% 0.209 151.711) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-green-400) 50%, transparent);
    }
  }
  .border-green-500 {
    border-color: var(--color-green-500);
  }
  .border-green-500\\/30 {
    border-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-green-500) 30%, transparent);
    }
  }
  .border-green-500\\/50 {
    border-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-green-500) 50%, transparent);
    }
  }
  .border-green-500\\/70 {
    border-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-green-500) 70%, transparent);
    }
  }
  .border-green-600 {
    border-color: var(--color-green-600);
  }
  .border-green-700 {
    border-color: var(--color-green-700);
  }
  .border-green-800 {
    border-color: var(--color-green-800);
  }
  .border-indigo-700 {
    border-color: var(--color-indigo-700);
  }
  .border-input {
    border-color: var(--input);
  }
  .border-orange-500\\/40 {
    border-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-orange-500) 40%, transparent);
    }
  }
  .border-orange-800 {
    border-color: var(--color-orange-800);
  }
  .border-pink-500\\/50 {
    border-color: color-mix(in srgb, oklch(65.6% 0.241 354.308) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-pink-500) 50%, transparent);
    }
  }
  .border-primary {
    border-color: var(--primary);
  }
  .border-purple-500 {
    border-color: var(--color-purple-500);
  }
  .border-purple-500\\/30 {
    border-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-purple-500) 30%, transparent);
    }
  }
  .border-purple-500\\/50 {
    border-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-purple-500) 50%, transparent);
    }
  }
  .border-purple-700 {
    border-color: var(--color-purple-700);
  }
  .border-red-400\\/30 {
    border-color: color-mix(in srgb, oklch(70.4% 0.191 22.216) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-400) 30%, transparent);
    }
  }
  .border-red-400\\/40 {
    border-color: color-mix(in srgb, oklch(70.4% 0.191 22.216) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-400) 40%, transparent);
    }
  }
  .border-red-400\\/50 {
    border-color: color-mix(in srgb, oklch(70.4% 0.191 22.216) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-400) 50%, transparent);
    }
  }
  .border-red-500 {
    border-color: var(--color-red-500);
  }
  .border-red-500\\/20 {
    border-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-500) 20%, transparent);
    }
  }
  .border-red-500\\/30 {
    border-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-500) 30%, transparent);
    }
  }
  .border-red-500\\/40 {
    border-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-500) 40%, transparent);
    }
  }
  .border-red-500\\/50 {
    border-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-500) 50%, transparent);
    }
  }
  .border-red-700 {
    border-color: var(--color-red-700);
  }
  .border-red-800 {
    border-color: var(--color-red-800);
  }
  .border-red-900\\/60 {
    border-color: color-mix(in srgb, oklch(39.6% 0.141 25.723) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-red-900) 60%, transparent);
    }
  }
  .border-sidebar-border {
    border-color: var(--sidebar-border);
  }
  .border-slate-200 {
    border-color: var(--color-slate-200);
  }
  .border-slate-300 {
    border-color: var(--color-slate-300);
  }
  .border-slate-500 {
    border-color: var(--color-slate-500);
  }
  .border-slate-500\\/30 {
    border-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-500) 30%, transparent);
    }
  }
  .border-slate-500\\/50 {
    border-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-500) 50%, transparent);
    }
  }
  .border-slate-600 {
    border-color: var(--color-slate-600);
  }
  .border-slate-600\\/30 {
    border-color: color-mix(in srgb, oklch(44.6% 0.043 257.281) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-600) 30%, transparent);
    }
  }
  .border-slate-700 {
    border-color: var(--color-slate-700);
  }
  .border-slate-700\\/40 {
    border-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-700) 40%, transparent);
    }
  }
  .border-slate-700\\/50 {
    border-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-700) 50%, transparent);
    }
  }
  .border-slate-700\\/60 {
    border-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-700) 60%, transparent);
    }
  }
  .border-slate-800 {
    border-color: var(--color-slate-800);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white {
    border-color: var(--color-white);
  }
  .border-yellow-400\\/50 {
    border-color: color-mix(in srgb, oklch(85.2% 0.199 91.936) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-yellow-400) 50%, transparent);
    }
  }
  .border-yellow-500 {
    border-color: var(--color-yellow-500);
  }
  .border-yellow-500\\/30 {
    border-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-yellow-500) 30%, transparent);
    }
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .border-l-transparent {
    border-left-color: transparent;
  }
  .bg-\\(--color-bg\\) {
    background-color: var(--color-bg);
  }
  .bg-\\[color\\:var\\(--mc-bg\\)\\] {
    background-color: var(--mc-bg);
  }
  .bg-\\[color\\:var\\(--mc-divider\\)\\] {
    background-color: var(--mc-divider);
  }
  .bg-\\[color\\:var\\(--mc-divider-soft\\)\\] {
    background-color: var(--mc-divider-soft);
  }
  .bg-\\[color\\:var\\(--mc-divider-soft\\)\\]\\/40 {
    background-color: var(--mc-divider-soft);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--mc-divider-soft) 40%, transparent);
    }
  }
  .bg-\\[color\\:var\\(--mc-surface-raised\\)\\] {
    background-color: var(--mc-surface-raised);
  }
  .bg-\\[rgba\\(29\\,224\\,197\\,0\\.08\\)\\] {
    background-color: rgba(29,224,197,0.08);
  }
  .bg-\\[rgba\\(95\\,214\\,146\\,0\\.06\\)\\] {
    background-color: rgba(95,214,146,0.06);
  }
  .bg-\\[rgba\\(95\\,214\\,146\\,0\\.08\\)\\] {
    background-color: rgba(95,214,146,0.08);
  }
  .bg-\\[rgba\\(95\\,214\\,146\\,0\\.12\\)\\] {
    background-color: rgba(95,214,146,0.12);
  }
  .bg-\\[rgba\\(95\\,214\\,146\\,0\\.16\\)\\] {
    background-color: rgba(95,214,146,0.16);
  }
  .bg-\\[rgba\\(184\\,85\\,231\\,0\\.08\\)\\] {
    background-color: rgba(184,85,231,0.08);
  }
  .bg-\\[rgba\\(244\\,122\\,165\\,0\\.03\\)\\] {
    background-color: rgba(244,122,165,0.03);
  }
  .bg-\\[rgba\\(244\\,122\\,165\\,0\\.05\\)\\] {
    background-color: rgba(244,122,165,0.05);
  }
  .bg-\\[rgba\\(244\\,122\\,165\\,0\\.08\\)\\] {
    background-color: rgba(244,122,165,0.08);
  }
  .bg-\\[rgba\\(245\\,158\\,11\\,0\\.08\\)\\] {
    background-color: rgba(245,158,11,0.08);
  }
  .bg-\\[rgba\\(248\\,199\\,88\\,0\\.08\\)\\] {
    background-color: rgba(248,199,88,0.08);
  }
  .bg-accent {
    background-color: var(--accent);
  }
  .bg-amber-100 {
    background-color: var(--color-amber-100);
  }
  .bg-amber-400 {
    background-color: var(--color-amber-400);
  }
  .bg-amber-400\\/10 {
    background-color: color-mix(in srgb, oklch(82.8% 0.189 84.429) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-400) 10%, transparent);
    }
  }
  .bg-amber-500 {
    background-color: var(--color-amber-500);
  }
  .bg-amber-500\\/5 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 5%, transparent);
    }
  }
  .bg-amber-500\\/10 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 10%, transparent);
    }
  }
  .bg-amber-500\\/15 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 15%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 15%, transparent);
    }
  }
  .bg-amber-500\\/20 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 20%, transparent);
    }
  }
  .bg-amber-500\\/30 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 30%, transparent);
    }
  }
  .bg-amber-600 {
    background-color: var(--color-amber-600);
  }
  .bg-amber-600\\/60 {
    background-color: color-mix(in srgb, oklch(66.6% 0.179 58.318) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-600) 60%, transparent);
    }
  }
  .bg-amber-900\\/50 {
    background-color: color-mix(in srgb, oklch(41.4% 0.112 45.904) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-900) 50%, transparent);
    }
  }
  .bg-background {
    background-color: var(--background);
  }
  .bg-black\\/40 {
    background-color: color-mix(in srgb, #000 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 40%, transparent);
    }
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-black\\/60 {
    background-color: color-mix(in srgb, #000 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 60%, transparent);
    }
  }
  .bg-black\\/70 {
    background-color: color-mix(in srgb, #000 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 70%, transparent);
    }
  }
  .bg-black\\/80 {
    background-color: color-mix(in srgb, #000 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
  }
  .bg-blue-100 {
    background-color: var(--color-blue-100);
  }
  .bg-blue-400 {
    background-color: var(--color-blue-400);
  }
  .bg-blue-500 {
    background-color: var(--color-blue-500);
  }
  .bg-blue-500\\/10 {
    background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-500) 10%, transparent);
    }
  }
  .bg-blue-500\\/20 {
    background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-500) 20%, transparent);
    }
  }
  .bg-blue-600 {
    background-color: var(--color-blue-600);
  }
  .bg-blue-900\\/50 {
    background-color: color-mix(in srgb, oklch(37.9% 0.146 265.522) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-900) 50%, transparent);
    }
  }
  .bg-border {
    background-color: var(--border);
  }
  .bg-card {
    background-color: var(--card);
  }
  .bg-cyan-500 {
    background-color: var(--color-cyan-500);
  }
  .bg-cyan-900\\/50 {
    background-color: color-mix(in srgb, oklch(39.8% 0.07 227.392) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-cyan-900) 50%, transparent);
    }
  }
  .bg-destructive {
    background-color: var(--destructive);
  }
  .bg-emerald-400 {
    background-color: var(--color-emerald-400);
  }
  .bg-emerald-500 {
    background-color: var(--color-emerald-500);
  }
  .bg-emerald-500\\/10 {
    background-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-emerald-500) 10%, transparent);
    }
  }
  .bg-emerald-500\\/15 {
    background-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 15%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-emerald-500) 15%, transparent);
    }
  }
  .bg-emerald-500\\/20 {
    background-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-emerald-500) 20%, transparent);
    }
  }
  .bg-emerald-600 {
    background-color: var(--color-emerald-600);
  }
  .bg-foreground {
    background-color: var(--foreground);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-400 {
    background-color: var(--color-gray-400);
  }
  .bg-gray-500\\/20 {
    background-color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-500) 20%, transparent);
    }
  }
  .bg-gray-800 {
    background-color: var(--color-gray-800);
  }
  .bg-gray-900 {
    background-color: var(--color-gray-900);
  }
  .bg-green-50\\/10 {
    background-color: color-mix(in srgb, oklch(98.2% 0.018 155.826) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-50) 10%, transparent);
    }
  }
  .bg-green-100 {
    background-color: var(--color-green-100);
  }
  .bg-green-500 {
    background-color: var(--color-green-500);
  }
  .bg-green-500\\/5 {
    background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-500) 5%, transparent);
    }
  }
  .bg-green-500\\/10 {
    background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-500) 10%, transparent);
    }
  }
  .bg-green-500\\/20 {
    background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-500) 20%, transparent);
    }
  }
  .bg-green-500\\/30 {
    background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-500) 30%, transparent);
    }
  }
  .bg-green-600 {
    background-color: var(--color-green-600);
  }
  .bg-green-600\\/60 {
    background-color: color-mix(in srgb, oklch(62.7% 0.194 149.214) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-600) 60%, transparent);
    }
  }
  .bg-green-900\\/20 {
    background-color: color-mix(in srgb, oklch(39.3% 0.095 152.535) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-900) 20%, transparent);
    }
  }
  .bg-green-900\\/50 {
    background-color: color-mix(in srgb, oklch(39.3% 0.095 152.535) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-900) 50%, transparent);
    }
  }
  .bg-indigo-500 {
    background-color: var(--color-indigo-500);
  }
  .bg-indigo-900\\/50 {
    background-color: color-mix(in srgb, oklch(35.9% 0.144 278.697) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-indigo-900) 50%, transparent);
    }
  }
  .bg-muted {
    background-color: var(--muted);
  }
  .bg-muted\\/50 {
    background-color: var(--muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--muted) 50%, transparent);
    }
  }
  .bg-orange-500 {
    background-color: var(--color-orange-500);
  }
  .bg-orange-600 {
    background-color: var(--color-orange-600);
  }
  .bg-pink-500 {
    background-color: var(--color-pink-500);
  }
  .bg-pink-500\\/10 {
    background-color: color-mix(in srgb, oklch(65.6% 0.241 354.308) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-pink-500) 10%, transparent);
    }
  }
  .bg-popover {
    background-color: var(--popover);
  }
  .bg-primary {
    background-color: var(--primary);
  }
  .bg-primary\\/20 {
    background-color: var(--primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--primary) 20%, transparent);
    }
  }
  .bg-purple-400 {
    background-color: var(--color-purple-400);
  }
  .bg-purple-500 {
    background-color: var(--color-purple-500);
  }
  .bg-purple-500\\/10 {
    background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-purple-500) 10%, transparent);
    }
  }
  .bg-purple-500\\/20 {
    background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-purple-500) 20%, transparent);
    }
  }
  .bg-purple-600 {
    background-color: var(--color-purple-600);
  }
  .bg-purple-900\\/50 {
    background-color: color-mix(in srgb, oklch(38.1% 0.176 304.987) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-purple-900) 50%, transparent);
    }
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-red-500\\/5 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 5%, transparent);
    }
  }
  .bg-red-500\\/10 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 10%, transparent);
    }
  }
  .bg-red-500\\/20 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 20%, transparent);
    }
  }
  .bg-red-600 {
    background-color: var(--color-red-600);
  }
  .bg-red-900\\/20 {
    background-color: color-mix(in srgb, oklch(39.6% 0.141 25.723) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-900) 20%, transparent);
    }
  }
  .bg-red-900\\/30 {
    background-color: color-mix(in srgb, oklch(39.6% 0.141 25.723) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-900) 30%, transparent);
    }
  }
  .bg-red-900\\/50 {
    background-color: color-mix(in srgb, oklch(39.6% 0.141 25.723) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-900) 50%, transparent);
    }
  }
  .bg-red-950\\/30 {
    background-color: color-mix(in srgb, oklch(25.8% 0.092 26.042) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-950) 30%, transparent);
    }
  }
  .bg-rose-600 {
    background-color: var(--color-rose-600);
  }
  .bg-secondary {
    background-color: var(--secondary);
  }
  .bg-sidebar {
    background-color: var(--sidebar);
  }
  .bg-sidebar-border {
    background-color: var(--sidebar-border);
  }
  .bg-slate-100 {
    background-color: var(--color-slate-100);
  }
  .bg-slate-500 {
    background-color: var(--color-slate-500);
  }
  .bg-slate-500\\/10 {
    background-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-500) 10%, transparent);
    }
  }
  .bg-slate-500\\/20 {
    background-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-500) 20%, transparent);
    }
  }
  .bg-slate-500\\/50 {
    background-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-500) 50%, transparent);
    }
  }
  .bg-slate-600 {
    background-color: var(--color-slate-600);
  }
  .bg-slate-600\\/30 {
    background-color: color-mix(in srgb, oklch(44.6% 0.043 257.281) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-600) 30%, transparent);
    }
  }
  .bg-slate-600\\/40 {
    background-color: color-mix(in srgb, oklch(44.6% 0.043 257.281) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-600) 40%, transparent);
    }
  }
  .bg-slate-600\\/50 {
    background-color: color-mix(in srgb, oklch(44.6% 0.043 257.281) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-600) 50%, transparent);
    }
  }
  .bg-slate-700 {
    background-color: var(--color-slate-700);
  }
  .bg-slate-700\\/30 {
    background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-700) 30%, transparent);
    }
  }
  .bg-slate-700\\/40 {
    background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-700) 40%, transparent);
    }
  }
  .bg-slate-700\\/50 {
    background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-700) 50%, transparent);
    }
  }
  .bg-slate-700\\/60 {
    background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-700) 60%, transparent);
    }
  }
  .bg-slate-800 {
    background-color: var(--color-slate-800);
  }
  .bg-slate-800\\/30 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 30%, transparent);
    }
  }
  .bg-slate-800\\/40 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 40%, transparent);
    }
  }
  .bg-slate-800\\/50 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 50%, transparent);
    }
  }
  .bg-slate-800\\/60 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 60%, transparent);
    }
  }
  .bg-slate-800\\/70 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 70%, transparent);
    }
  }
  .bg-slate-800\\/80 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 80%, transparent);
    }
  }
  .bg-slate-800\\/95 {
    background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-800) 95%, transparent);
    }
  }
  .bg-slate-900 {
    background-color: var(--color-slate-900);
  }
  .bg-slate-900\\/30 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 30%, transparent);
    }
  }
  .bg-slate-900\\/40 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 40%, transparent);
    }
  }
  .bg-slate-900\\/50 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 50%, transparent);
    }
  }
  .bg-slate-900\\/60 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 60%, transparent);
    }
  }
  .bg-slate-900\\/80 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 80%, transparent);
    }
  }
  .bg-slate-900\\/95 {
    background-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-900) 95%, transparent);
    }
  }
  .bg-slate-950 {
    background-color: var(--color-slate-950);
  }
  .bg-teal-500 {
    background-color: var(--color-teal-500);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/95 {
    background-color: color-mix(in srgb, #fff 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 95%, transparent);
    }
  }
  .bg-yellow-50\\/10 {
    background-color: color-mix(in srgb, oklch(98.7% 0.026 102.212) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow-50) 10%, transparent);
    }
  }
  .bg-yellow-100 {
    background-color: var(--color-yellow-100);
  }
  .bg-yellow-500 {
    background-color: var(--color-yellow-500);
  }
  .bg-yellow-500\\/20 {
    background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow-500) 20%, transparent);
    }
  }
  .bg-gradient-to-b {
    --tw-gradient-position: to bottom in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-br {
    --tw-gradient-position: to bottom right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-l {
    --tw-gradient-position: to left in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-r {
    --tw-gradient-position: to right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\[linear-gradient\\(90deg\\,var\\(--mc-green\\)\\,transparent\\)\\] {
    background-image: linear-gradient(90deg,var(--mc-green),transparent);
  }
  .bg-\\[linear-gradient\\(90deg\\,var\\(--mc-magenta\\)\\,transparent\\)\\] {
    background-image: linear-gradient(90deg,var(--mc-magenta),transparent);
  }
  .bg-\\[url\\(\\'\\/luxury-golf-simulator\\.png\\'\\)\\] {
    background-image: url('/luxury-golf-simulator.png');
  }
  .from-\\[var\\(--mc-cyan\\)\\] {
    --tw-gradient-from: var(--mc-cyan);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-\\[var\\(--mc-magenta\\)\\] {
    --tw-gradient-from: var(--mc-magenta);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-amber-400 {
    --tw-gradient-from: var(--color-amber-400);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-amber-500 {
    --tw-gradient-from: var(--color-amber-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-amber-500\\/10 {
    --tw-gradient-from: color-mix(in srgb, oklch(76.9% 0.188 70.08) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-amber-500) 10%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-amber-500\\/20 {
    --tw-gradient-from: color-mix(in srgb, oklch(76.9% 0.188 70.08) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-amber-500) 20%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-amber-600 {
    --tw-gradient-from: var(--color-amber-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-cyan-400 {
    --tw-gradient-from: var(--color-cyan-400);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-emerald-600 {
    --tw-gradient-from: var(--color-emerald-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-green-50 {
    --tw-gradient-from: var(--color-green-50);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-purple-600 {
    --tw-gradient-from: var(--color-purple-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-rose-600 {
    --tw-gradient-from: var(--color-rose-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-sky-600 {
    --tw-gradient-from: var(--color-sky-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-slate-800\\/80 {
    --tw-gradient-from: color-mix(in srgb, oklch(27.9% 0.041 260.031) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-slate-800) 80%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-slate-900 {
    --tw-gradient-from: var(--color-slate-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .via-\\[var\\(--mc-amber\\)\\] {
    --tw-gradient-via: var(--mc-amber);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-\\[var\\(--mc-purple\\)\\] {
    --tw-gradient-via: var(--mc-purple);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-fuchsia-400 {
    --tw-gradient-via: var(--color-fuchsia-400);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-slate-800 {
    --tw-gradient-via: var(--color-slate-800);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-slate-950 {
    --tw-gradient-via: var(--color-slate-950);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-yellow-500 {
    --tw-gradient-via: var(--color-yellow-500);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .to-amber-600 {
    --tw-gradient-to: var(--color-amber-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-amber-600\\/10 {
    --tw-gradient-to: color-mix(in srgb, oklch(66.6% 0.179 58.318) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-amber-600) 10%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-black {
    --tw-gradient-to: var(--color-black);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-blue-600 {
    --tw-gradient-to: var(--color-blue-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-emerald-300 {
    --tw-gradient-to: var(--color-emerald-300);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-orange-600 {
    --tw-gradient-to: var(--color-orange-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-pink-600 {
    --tw-gradient-to: var(--color-pink-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-teal-600 {
    --tw-gradient-to: var(--color-teal-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-transparent {
    --tw-gradient-to: transparent;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-white {
    --tw-gradient-to: var(--color-white);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-yellow-500 {
    --tw-gradient-to: var(--color-yellow-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-yellow-500\\/10 {
    --tw-gradient-to: color-mix(in srgb, oklch(79.5% 0.184 86.047) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-yellow-500) 10%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-yellow-500\\/20 {
    --tw-gradient-to: color-mix(in srgb, oklch(79.5% 0.184 86.047) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-yellow-500) 20%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-yellow-600 {
    --tw-gradient-to: var(--color-yellow-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-clip-text {
    background-clip: text;
  }
  .bg-center {
    background-position: center;
  }
  .fill-current {
    fill: currentcolor;
  }
  .fill-primary {
    fill: var(--primary);
  }
  .fill-slate-800 {
    fill: var(--color-slate-800);
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .p-0 {
    padding: 0px;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: var(--spacing);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-\\[3px\\] {
    padding: 3px;
  }
  .p-px {
    padding: 1px;
  }
  .px-\\(--cell-size\\) {
    padding-inline: var(--cell-size);
  }
  .px-0 {
    padding-inline: 0px;
  }
  .px-1 {
    padding-inline: var(--spacing);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10);
  }
  .py-0 {
    padding-block: 0px;
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: var(--spacing);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-10 {
    padding-block: calc(var(--spacing) * 10);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-16 {
    padding-block: calc(var(--spacing) * 16);
  }
  .py-20 {
    padding-block: calc(var(--spacing) * 20);
  }
  .py-24 {
    padding-block: calc(var(--spacing) * 24);
  }
  .pt-0 {
    padding-top: 0px;
  }
  .pt-1 {
    padding-top: var(--spacing);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pr-1 {
    padding-right: var(--spacing);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-2\\.5 {
    padding-right: calc(var(--spacing) * 2.5);
  }
  .pr-3 {
    padding-right: calc(var(--spacing) * 3);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-6 {
    padding-right: calc(var(--spacing) * 6);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pr-10 {
    padding-right: calc(var(--spacing) * 10);
  }
  .pb-0 {
    padding-bottom: 0px;
  }
  .pb-1 {
    padding-bottom: var(--spacing);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-6 {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .pl-0 {
    padding-left: 0px;
  }
  .pl-1 {
    padding-left: var(--spacing);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-6 {
    padding-left: calc(var(--spacing) * 6);
  }
  .pl-7 {
    padding-left: calc(var(--spacing) * 7);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .pl-10 {
    padding-left: calc(var(--spacing) * 10);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .align-middle {
    vertical-align: middle;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[0\\.8rem\\] {
    font-size: 0.8rem;
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .leading-\\[1\\.5\\] {
    --tw-leading: 1.5;
    line-height: 1.5;
  }
  .leading-\\[1\\.45\\] {
    --tw-leading: 1.45;
    line-height: 1.45;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[-0\\.03em\\] {
    --tw-tracking: -0.03em;
    letter-spacing: -0.03em;
  }
  .tracking-\\[0\\.2em\\] {
    --tw-tracking: 0.2em;
    letter-spacing: 0.2em;
  }
  .tracking-\\[0\\.12em\\] {
    --tw-tracking: 0.12em;
    letter-spacing: 0.12em;
  }
  .tracking-\\[0\\.16em\\] {
    --tw-tracking: 0.16em;
    letter-spacing: 0.16em;
  }
  .tracking-\\[3px\\] {
    --tw-tracking: 3px;
    letter-spacing: 3px;
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .text-balance {
    text-wrap: balance;
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .text-\\[color\\:var\\(--mc-amber\\)\\] {
    color: var(--mc-amber);
  }
  .text-\\[color\\:var\\(--mc-cyan\\)\\] {
    color: var(--mc-cyan);
  }
  .text-\\[color\\:var\\(--mc-gray\\)\\] {
    color: var(--mc-gray);
  }
  .text-\\[color\\:var\\(--mc-gray-dim\\)\\] {
    color: var(--mc-gray-dim);
  }
  .text-\\[color\\:var\\(--mc-green\\)\\] {
    color: var(--mc-green);
  }
  .text-\\[color\\:var\\(--mc-magenta\\)\\] {
    color: var(--mc-magenta);
  }
  .text-\\[color\\:var\\(--mc-purple\\)\\] {
    color: var(--mc-purple);
  }
  .text-\\[color\\:var\\(--mc-text-accent-pink\\)\\] {
    color: var(--mc-text-accent-pink);
  }
  .text-\\[color\\:var\\(--mc-text-accent-pink\\,\\#ff5caa\\)\\] {
    color: var(--mc-text-accent-pink,#ff5caa);
  }
  .text-\\[color\\:var\\(--mc-text-hero\\)\\] {
    color: var(--mc-text-hero);
  }
  .text-\\[color\\:var\\(--mc-text-meta\\)\\] {
    color: var(--mc-text-meta);
  }
  .text-\\[color\\:var\\(--mc-text-meta\\,\\#94a3b8\\)\\] {
    color: var(--mc-text-meta,#94a3b8);
  }
  .text-\\[color\\:var\\(--mc-text-primary\\)\\] {
    color: var(--mc-text-primary);
  }
  .text-\\[color\\:var\\(--mc-text-secondary\\)\\] {
    color: var(--mc-text-secondary);
  }
  .text-\\[color\\:var\\(--mc-white\\)\\] {
    color: var(--mc-white);
  }
  .text-accent-foreground {
    color: var(--accent-foreground);
  }
  .text-amber-100\\/90 {
    color: color-mix(in srgb, oklch(96.2% 0.059 95.617) 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-amber-100) 90%, transparent);
    }
  }
  .text-amber-200 {
    color: var(--color-amber-200);
  }
  .text-amber-300 {
    color: var(--color-amber-300);
  }
  .text-amber-400 {
    color: var(--color-amber-400);
  }
  .text-amber-400\\/80 {
    color: color-mix(in srgb, oklch(82.8% 0.189 84.429) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-amber-400) 80%, transparent);
    }
  }
  .text-amber-500 {
    color: var(--color-amber-500);
  }
  .text-amber-600 {
    color: var(--color-amber-600);
  }
  .text-amber-800 {
    color: var(--color-amber-800);
  }
  .text-black {
    color: var(--color-black);
  }
  .text-blue-200 {
    color: var(--color-blue-200);
  }
  .text-blue-300 {
    color: var(--color-blue-300);
  }
  .text-blue-400 {
    color: var(--color-blue-400);
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-blue-800 {
    color: var(--color-blue-800);
  }
  .text-card-foreground {
    color: var(--card-foreground);
  }
  .text-current {
    color: currentcolor;
  }
  .text-cyan-200 {
    color: var(--color-cyan-200);
  }
  .text-cyan-300 {
    color: var(--color-cyan-300);
  }
  .text-destructive {
    color: var(--destructive);
  }
  .text-destructive-foreground {
    color: var(--destructive-foreground);
  }
  .text-emerald-300 {
    color: var(--color-emerald-300);
  }
  .text-emerald-400 {
    color: var(--color-emerald-400);
  }
  .text-emerald-500 {
    color: var(--color-emerald-500);
  }
  .text-emerald-700 {
    color: var(--color-emerald-700);
  }
  .text-foreground {
    color: var(--foreground);
  }
  .text-foreground\\/50 {
    color: var(--foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--foreground) 50%, transparent);
    }
  }
  .text-gray-300 {
    color: var(--color-gray-300);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-green-200 {
    color: var(--color-green-200);
  }
  .text-green-300 {
    color: var(--color-green-300);
  }
  .text-green-400 {
    color: var(--color-green-400);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-800 {
    color: var(--color-green-800);
  }
  .text-indigo-300 {
    color: var(--color-indigo-300);
  }
  .text-muted-foreground {
    color: var(--muted-foreground);
  }
  .text-orange-400 {
    color: var(--color-orange-400);
  }
  .text-pink-300 {
    color: var(--color-pink-300);
  }
  .text-pink-400 {
    color: var(--color-pink-400);
  }
  .text-pink-500 {
    color: var(--color-pink-500);
  }
  .text-popover-foreground {
    color: var(--popover-foreground);
  }
  .text-primary {
    color: var(--primary);
  }
  .text-primary-foreground {
    color: var(--primary-foreground);
  }
  .text-purple-300 {
    color: var(--color-purple-300);
  }
  .text-purple-400 {
    color: var(--color-purple-400);
  }
  .text-red-100 {
    color: var(--color-red-100);
  }
  .text-red-100\\/80 {
    color: color-mix(in srgb, oklch(93.6% 0.032 17.717) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-red-100) 80%, transparent);
    }
  }
  .text-red-200\\/70 {
    color: color-mix(in srgb, oklch(88.5% 0.062 18.334) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-red-200) 70%, transparent);
    }
  }
  .text-red-300 {
    color: var(--color-red-300);
  }
  .text-red-400 {
    color: var(--color-red-400);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-800 {
    color: var(--color-red-800);
  }
  .text-secondary-foreground {
    color: var(--secondary-foreground);
  }
  .text-sidebar-foreground {
    color: var(--sidebar-foreground);
  }
  .text-sidebar-foreground\\/70 {
    color: var(--sidebar-foreground);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--sidebar-foreground) 70%, transparent);
    }
  }
  .text-slate-100 {
    color: var(--color-slate-100);
  }
  .text-slate-200 {
    color: var(--color-slate-200);
  }
  .text-slate-300 {
    color: var(--color-slate-300);
  }
  .text-slate-400 {
    color: var(--color-slate-400);
  }
  .text-slate-500 {
    color: var(--color-slate-500);
  }
  .text-slate-600 {
    color: var(--color-slate-600);
  }
  .text-slate-700 {
    color: var(--color-slate-700);
  }
  .text-slate-800 {
    color: var(--color-slate-800);
  }
  .text-slate-900 {
    color: var(--color-slate-900);
  }
  .text-transparent {
    color: transparent;
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\/90 {
    color: color-mix(in srgb, #fff 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 90%, transparent);
    }
  }
  .text-yellow-300 {
    color: var(--color-yellow-300);
  }
  .text-yellow-400 {
    color: var(--color-yellow-400);
  }
  .text-yellow-800 {
    color: var(--color-yellow-800);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-4 {
    text-underline-offset: 4px;
  }
  .placeholder-slate-400::placeholder {
    color: var(--color-slate-400);
  }
  .accent-amber-500 {
    accent-color: var(--color-amber-500);
  }
  .\\[color-scheme\\:dark\\] {
    color-scheme: dark;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-10 {
    opacity: 10%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-30 {
    opacity: 30%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-90 {
    opacity: 90%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\] {
    --tw-shadow: 0 0 0 1px var(--tw-shadow-color, hsl(var(--sidebar-border)));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-amber-500\\/20 {
    --tw-shadow-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-amber-500) 20%, transparent) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-amber-500\\/25 {
    --tw-shadow-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 25%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-amber-500) 25%, transparent) var(--tw-shadow-alpha), transparent);
    }
  }
  .ring-amber-500 {
    --tw-ring-color: var(--color-amber-500);
  }
  .ring-blue-500 {
    --tw-ring-color: var(--color-blue-500);
  }
  .ring-green-500 {
    --tw-ring-color: var(--color-green-500);
  }
  .ring-ring\\/50 {
    --tw-ring-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  .ring-sidebar-ring {
    --tw-ring-color: var(--sidebar-ring);
  }
  .ring-offset-background {
    --tw-ring-offset-color: var(--background);
  }
  .outline-hidden {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur-3xl {
    --tw-blur: blur(var(--blur-3xl));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur {
    --tw-backdrop-blur: blur(8px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[color\\,box-shadow\\] {
    transition-property: color,box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[left\\,right\\,width\\] {
    transition-property: left,right,width;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[margin\\,opacity\\] {
    transition-property: margin,opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\,height\\,padding\\] {
    transition-property: width,height,padding;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-none {
    transition-property: none;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-1000 {
    --tw-duration: 1000ms;
    transition-duration: 1000ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-linear {
    --tw-ease: linear;
    transition-timing-function: linear;
  }
  .fade-in-0 {
    --tw-enter-opacity: calc(0/100);
    --tw-enter-opacity: 0;
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .zoom-in-95 {
    --tw-enter-scale: calc(95*1%);
    --tw-enter-scale: .95;
  }
  .\\[--cell-size\\:--spacing\\(8\\)\\] {
    --cell-size: calc(var(--spacing) * 8);
  }
  .group-focus-within\\/menu-item\\:opacity-100:is(:where(.group\\/menu-item):focus-within *) {
    opacity: 100%;
  }
  @media (hover: hover) {
    .group-hover\\:block:is(:where(.group):hover *) {
      display: block;
    }
    .group-hover\\:text-\\[color\\:var\\(--mc-cyan\\)\\]:is(:where(.group):hover *) {
      color: var(--mc-cyan);
    }
    .group-hover\\:text-amber-400:is(:where(.group):hover *) {
      color: var(--color-amber-400);
    }
    .group-hover\\:opacity-100:is(:where(.group):hover *) {
      opacity: 100%;
    }
    .group-hover\\/menu-item\\:opacity-100:is(:where(.group\\/menu-item):hover *) {
      opacity: 100%;
    }
  }
  .group-has-data-\\[sidebar\\=menu-action\\]\\/menu-item\\:pr-8:is(:where(.group\\/menu-item):has([data-sidebar="menu-action"]) *) {
    padding-right: calc(var(--spacing) * 8);
  }
  .group-data-\\[collapsible\\=icon\\]\\:-mt-8:is(:where(.group)[data-collapsible="icon"] *) {
    margin-top: calc(var(--spacing) * -8);
  }
  .group-data-\\[collapsible\\=icon\\]\\:hidden:is(:where(.group)[data-collapsible="icon"] *) {
    display: none;
  }
  .group-data-\\[collapsible\\=icon\\]\\:size-8\\!:is(:where(.group)[data-collapsible="icon"] *) {
    width: calc(var(--spacing) * 8) !important;
    height: calc(var(--spacing) * 8) !important;
  }
  .group-data-\\[collapsible\\=icon\\]\\:w-\\(--sidebar-width-icon\\):is(:where(.group)[data-collapsible="icon"] *) {
    width: var(--sidebar-width-icon);
  }
  .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)\\+\\(--spacing\\(4\\)\\)\\)\\]:is(:where(.group)[data-collapsible="icon"] *) {
    width: calc(var(--sidebar-width-icon) + (calc(var(--spacing) * 4)));
  }
  .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)\\+\\(--spacing\\(4\\)\\)\\+2px\\)\\]:is(:where(.group)[data-collapsible="icon"] *) {
    width: calc(var(--sidebar-width-icon) + (calc(var(--spacing) * 4)) + 2px);
  }
  .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden:is(:where(.group)[data-collapsible="icon"] *) {
    overflow: hidden;
  }
  .group-data-\\[collapsible\\=icon\\]\\:p-0\\!:is(:where(.group)[data-collapsible="icon"] *) {
    padding: 0px !important;
  }
  .group-data-\\[collapsible\\=icon\\]\\:p-2\\!:is(:where(.group)[data-collapsible="icon"] *) {
    padding: calc(var(--spacing) * 2) !important;
  }
  .group-data-\\[collapsible\\=icon\\]\\:opacity-0:is(:where(.group)[data-collapsible="icon"] *) {
    opacity: 0%;
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]:is(:where(.group)[data-collapsible="offcanvas"] *) {
    right: calc(var(--sidebar-width) * -1);
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]:is(:where(.group)[data-collapsible="offcanvas"] *) {
    left: calc(var(--sidebar-width) * -1);
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:w-0:is(:where(.group)[data-collapsible="offcanvas"] *) {
    width: 0px;
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0:is(:where(.group)[data-collapsible="offcanvas"] *) {
    --tw-translate-x: 0px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .group-data-\\[disabled\\=true\\]\\:pointer-events-none:is(:where(.group)[data-disabled="true"] *) {
    pointer-events: none;
  }
  .group-data-\\[disabled\\=true\\]\\:opacity-50:is(:where(.group)[data-disabled="true"] *) {
    opacity: 50%;
  }
  .group-data-\\[focused\\=true\\]\\/day\\:relative:is(:where(.group\\/day)[data-focused="true"] *) {
    position: relative;
  }
  .group-data-\\[focused\\=true\\]\\/day\\:z-10:is(:where(.group\\/day)[data-focused="true"] *) {
    z-index: 10;
  }
  .group-data-\\[focused\\=true\\]\\/day\\:border-ring:is(:where(.group\\/day)[data-focused="true"] *) {
    border-color: var(--ring);
  }
  .group-data-\\[focused\\=true\\]\\/day\\:ring-\\[3px\\]:is(:where(.group\\/day)[data-focused="true"] *) {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .group-data-\\[focused\\=true\\]\\/day\\:ring-ring\\/50:is(:where(.group\\/day)[data-focused="true"] *) {
    --tw-ring-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  .group-data-\\[side\\=left\\]\\:-right-4:is(:where(.group)[data-side="left"] *) {
    right: calc(var(--spacing) * -4);
  }
  .group-data-\\[side\\=left\\]\\:border-r:is(:where(.group)[data-side="left"] *) {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .group-data-\\[side\\=right\\]\\:left-0:is(:where(.group)[data-side="right"] *) {
    left: 0px;
  }
  .group-data-\\[side\\=right\\]\\:rotate-180:is(:where(.group)[data-side="right"] *) {
    rotate: 180deg;
  }
  .group-data-\\[side\\=right\\]\\:border-l:is(:where(.group)[data-side="right"] *) {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .group-data-\\[state\\=open\\]\\:rotate-180:is(:where(.group)[data-state="open"] *) {
    rotate: 180deg;
  }
  .group-data-\\[variant\\=floating\\]\\:rounded-lg:is(:where(.group)[data-variant="floating"] *) {
    border-radius: var(--radius);
  }
  .group-data-\\[variant\\=floating\\]\\:border:is(:where(.group)[data-variant="floating"] *) {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .group-data-\\[variant\\=floating\\]\\:border-sidebar-border:is(:where(.group)[data-variant="floating"] *) {
    border-color: var(--sidebar-border);
  }
  .group-data-\\[variant\\=floating\\]\\:shadow-sm:is(:where(.group)[data-variant="floating"] *) {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .group-data-\\[vaul-drawer-direction\\=bottom\\]\\/drawer-content\\:block:is(:where(.group\\/drawer-content)[data-vaul-drawer-direction="bottom"] *) {
    display: block;
  }
  .group-data-\\[vaul-drawer-direction\\=bottom\\]\\/drawer-content\\:text-center:is(:where(.group\\/drawer-content)[data-vaul-drawer-direction="bottom"] *) {
    text-align: center;
  }
  .group-data-\\[vaul-drawer-direction\\=top\\]\\/drawer-content\\:text-center:is(:where(.group\\/drawer-content)[data-vaul-drawer-direction="top"] *) {
    text-align: center;
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:top-full:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    top: 100%;
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:mt-1\\.5:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:overflow-hidden:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    overflow: hidden;
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:rounded-md:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    border-radius: calc(var(--radius) - 2px);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:border:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:bg-popover:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    background-color: var(--popover);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:text-popover-foreground:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    color: var(--popover-foreground);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:shadow:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:duration-200:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .group-\\[\\.destructive\\]\\:border-muted\\/40:is(:where(.group):is(.destructive) *) {
    border-color: var(--muted);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--muted) 40%, transparent);
    }
  }
  .group-\\[\\.destructive\\]\\:text-red-300:is(:where(.group):is(.destructive) *) {
    color: var(--color-red-300);
  }
  @media (hover: hover) {
    .peer-hover\\/menu-button\\:text-sidebar-accent-foreground:is(:where(.peer\\/menu-button):hover ~ *) {
      color: var(--sidebar-accent-foreground);
    }
  }
  .peer-disabled\\:cursor-not-allowed:is(:where(.peer):disabled ~ *) {
    cursor: not-allowed;
  }
  .peer-disabled\\:opacity-50:is(:where(.peer):disabled ~ *) {
    opacity: 50%;
  }
  .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground:is(:where(.peer\\/menu-button)[data-active="true"] ~ *) {
    color: var(--sidebar-accent-foreground);
  }
  .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5:is(:where(.peer\\/menu-button)[data-size="default"] ~ *) {
    top: calc(var(--spacing) * 1.5);
  }
  .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5:is(:where(.peer\\/menu-button)[data-size="lg"] ~ *) {
    top: calc(var(--spacing) * 2.5);
  }
  .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1:is(:where(.peer\\/menu-button)[data-size="sm"] ~ *) {
    top: var(--spacing);
  }
  .selection\\:bg-primary ::selection {
    background-color: var(--primary);
  }
  .selection\\:bg-primary::selection {
    background-color: var(--primary);
  }
  .selection\\:text-primary-foreground ::selection {
    color: var(--primary-foreground);
  }
  .selection\\:text-primary-foreground::selection {
    color: var(--primary-foreground);
  }
  .file\\:inline-flex::file-selector-button {
    display: inline-flex;
  }
  .file\\:h-7::file-selector-button {
    height: calc(var(--spacing) * 7);
  }
  .file\\:border-0::file-selector-button {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .file\\:bg-transparent::file-selector-button {
    background-color: transparent;
  }
  .file\\:text-sm::file-selector-button {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .file\\:font-medium::file-selector-button {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .file\\:text-foreground::file-selector-button {
    color: var(--foreground);
  }
  .placeholder\\:text-muted-foreground::placeholder {
    color: var(--muted-foreground);
  }
  .placeholder\\:text-slate-400::placeholder {
    color: var(--color-slate-400);
  }
  .placeholder\\:text-slate-500::placeholder {
    color: var(--color-slate-500);
  }
  .after\\:absolute::after {
    content: var(--tw-content);
    position: absolute;
  }
  .after\\:-inset-2::after {
    content: var(--tw-content);
    inset: calc(var(--spacing) * -2);
  }
  .after\\:inset-y-0::after {
    content: var(--tw-content);
    inset-block: 0px;
  }
  .after\\:left-1\\/2::after {
    content: var(--tw-content);
    left: calc(1 / 2 * 100%);
  }
  .after\\:w-1::after {
    content: var(--tw-content);
    width: var(--spacing);
  }
  .after\\:w-\\[2px\\]::after {
    content: var(--tw-content);
    width: 2px;
  }
  .after\\:-translate-x-1\\/2::after {
    content: var(--tw-content);
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full:is(:where(.group)[data-collapsible="offcanvas"] *)::after {
    content: var(--tw-content);
    left: 100%;
  }
  .first\\:rounded-l-md:first-child {
    border-top-left-radius: calc(var(--radius) - 2px);
    border-bottom-left-radius: calc(var(--radius) - 2px);
  }
  .first\\:border-l:first-child {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .last\\:rounded-r-md:last-child {
    border-top-right-radius: calc(var(--radius) - 2px);
    border-bottom-right-radius: calc(var(--radius) - 2px);
  }
  .last\\:border-r-0:last-child {
    border-right-style: var(--tw-border-style);
    border-right-width: 0px;
  }
  .last\\:border-b-0:last-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .focus-within\\:relative:focus-within {
    position: relative;
  }
  .focus-within\\:z-20:focus-within {
    z-index: 20;
  }
  @media (hover: hover) {
    .hover\\:scale-\\[1\\.02\\]:hover {
      scale: 1.02;
    }
    .hover\\:border-\\[color\\:var\\(--mc-cyan\\)\\]:hover {
      border-color: var(--mc-cyan);
    }
    .hover\\:border-\\[color\\:var\\(--mc-magenta\\)\\]:hover {
      border-color: var(--mc-magenta);
    }
    .hover\\:border-amber-500:hover {
      border-color: var(--color-amber-500);
    }
    .hover\\:border-amber-500\\/30:hover {
      border-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:border-amber-500\\/30:hover {
        border-color: color-mix(in oklab, var(--color-amber-500) 30%, transparent);
      }
    }
    .hover\\:border-pink-400:hover {
      border-color: var(--color-pink-400);
    }
    .hover\\:border-slate-400:hover {
      border-color: var(--color-slate-400);
    }
    .hover\\:border-slate-500:hover {
      border-color: var(--color-slate-500);
    }
    .hover\\:border-slate-600:hover {
      border-color: var(--color-slate-600);
    }
    .hover\\:bg-\\[color\\:var\\(--mc-surface\\)\\]:hover {
      background-color: var(--mc-surface);
    }
    .hover\\:bg-\\[color\\:var\\(--mc-surface-raised\\)\\]:hover {
      background-color: var(--mc-surface-raised);
    }
    .hover\\:bg-\\[rgba\\(29\\,224\\,197\\,0\\.06\\)\\]:hover {
      background-color: rgba(29,224,197,0.06);
    }
    .hover\\:bg-\\[rgba\\(244\\,122\\,165\\,0\\.1\\)\\]:hover {
      background-color: rgba(244,122,165,0.1);
    }
    .hover\\:bg-accent:hover {
      background-color: var(--accent);
    }
    .hover\\:bg-amber-400:hover {
      background-color: var(--color-amber-400);
    }
    .hover\\:bg-amber-500:hover {
      background-color: var(--color-amber-500);
    }
    .hover\\:bg-amber-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-amber-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-amber-500) 10%, transparent);
      }
    }
    .hover\\:bg-amber-500\\/20:hover {
      background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 20%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-amber-500\\/20:hover {
        background-color: color-mix(in oklab, var(--color-amber-500) 20%, transparent);
      }
    }
    .hover\\:bg-amber-500\\/25:hover {
      background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 25%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-amber-500\\/25:hover {
        background-color: color-mix(in oklab, var(--color-amber-500) 25%, transparent);
      }
    }
    .hover\\:bg-amber-500\\/30:hover {
      background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-amber-500\\/30:hover {
        background-color: color-mix(in oklab, var(--color-amber-500) 30%, transparent);
      }
    }
    .hover\\:bg-amber-600:hover {
      background-color: var(--color-amber-600);
    }
    .hover\\:bg-amber-700:hover {
      background-color: var(--color-amber-700);
    }
    .hover\\:bg-blue-500:hover {
      background-color: var(--color-blue-500);
    }
    .hover\\:bg-blue-500\\/30:hover {
      background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-blue-500\\/30:hover {
        background-color: color-mix(in oklab, var(--color-blue-500) 30%, transparent);
      }
    }
    .hover\\:bg-blue-600:hover {
      background-color: var(--color-blue-600);
    }
    .hover\\:bg-blue-700:hover {
      background-color: var(--color-blue-700);
    }
    .hover\\:bg-destructive\\/90:hover {
      background-color: var(--destructive);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-destructive\\/90:hover {
        background-color: color-mix(in oklab, var(--destructive) 90%, transparent);
      }
    }
    .hover\\:bg-emerald-500:hover {
      background-color: var(--color-emerald-500);
    }
    .hover\\:bg-emerald-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-emerald-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-emerald-500) 10%, transparent);
      }
    }
    .hover\\:bg-emerald-500\\/25:hover {
      background-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 25%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-emerald-500\\/25:hover {
        background-color: color-mix(in oklab, var(--color-emerald-500) 25%, transparent);
      }
    }
    .hover\\:bg-emerald-500\\/30:hover {
      background-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-emerald-500\\/30:hover {
        background-color: color-mix(in oklab, var(--color-emerald-500) 30%, transparent);
      }
    }
    .hover\\:bg-emerald-700:hover {
      background-color: var(--color-emerald-700);
    }
    .hover\\:bg-gray-50:hover {
      background-color: var(--color-gray-50);
    }
    .hover\\:bg-gray-800:hover {
      background-color: var(--color-gray-800);
    }
    .hover\\:bg-green-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-green-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-green-500) 10%, transparent);
      }
    }
    .hover\\:bg-green-600:hover {
      background-color: var(--color-green-600);
    }
    .hover\\:bg-green-700:hover {
      background-color: var(--color-green-700);
    }
    .hover\\:bg-green-900\\/30:hover {
      background-color: color-mix(in srgb, oklch(39.3% 0.095 152.535) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-green-900\\/30:hover {
        background-color: color-mix(in oklab, var(--color-green-900) 30%, transparent);
      }
    }
    .hover\\:bg-muted:hover {
      background-color: var(--muted);
    }
    .hover\\:bg-muted\\/50:hover {
      background-color: var(--muted);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-muted\\/50:hover {
        background-color: color-mix(in oklab, var(--muted) 50%, transparent);
      }
    }
    .hover\\:bg-orange-500:hover {
      background-color: var(--color-orange-500);
    }
    .hover\\:bg-orange-900\\/30:hover {
      background-color: color-mix(in srgb, oklch(40.8% 0.123 38.172) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-orange-900\\/30:hover {
        background-color: color-mix(in oklab, var(--color-orange-900) 30%, transparent);
      }
    }
    .hover\\:bg-pink-500\\/20:hover {
      background-color: color-mix(in srgb, oklch(65.6% 0.241 354.308) 20%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-pink-500\\/20:hover {
        background-color: color-mix(in oklab, var(--color-pink-500) 20%, transparent);
      }
    }
    .hover\\:bg-primary\\/90:hover {
      background-color: var(--primary);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-primary\\/90:hover {
        background-color: color-mix(in oklab, var(--primary) 90%, transparent);
      }
    }
    .hover\\:bg-purple-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-purple-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-purple-500) 10%, transparent);
      }
    }
    .hover\\:bg-purple-500\\/30:hover {
      background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-purple-500\\/30:hover {
        background-color: color-mix(in oklab, var(--color-purple-500) 30%, transparent);
      }
    }
    .hover\\:bg-purple-700:hover {
      background-color: var(--color-purple-700);
    }
    .hover\\:bg-red-500:hover {
      background-color: var(--color-red-500);
    }
    .hover\\:bg-red-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-red-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-red-500) 10%, transparent);
      }
    }
    .hover\\:bg-red-500\\/20:hover {
      background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 20%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-red-500\\/20:hover {
        background-color: color-mix(in oklab, var(--color-red-500) 20%, transparent);
      }
    }
    .hover\\:bg-red-500\\/30:hover {
      background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-red-500\\/30:hover {
        background-color: color-mix(in oklab, var(--color-red-500) 30%, transparent);
      }
    }
    .hover\\:bg-red-600:hover {
      background-color: var(--color-red-600);
    }
    .hover\\:bg-red-700:hover {
      background-color: var(--color-red-700);
    }
    .hover\\:bg-red-900\\/30:hover {
      background-color: color-mix(in srgb, oklch(39.6% 0.141 25.723) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-red-900\\/30:hover {
        background-color: color-mix(in oklab, var(--color-red-900) 30%, transparent);
      }
    }
    .hover\\:bg-rose-700:hover {
      background-color: var(--color-rose-700);
    }
    .hover\\:bg-secondary:hover {
      background-color: var(--secondary);
    }
    .hover\\:bg-secondary\\/80:hover {
      background-color: var(--secondary);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-secondary\\/80:hover {
        background-color: color-mix(in oklab, var(--secondary) 80%, transparent);
      }
    }
    .hover\\:bg-sidebar-accent:hover {
      background-color: var(--sidebar-accent);
    }
    .hover\\:bg-slate-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-slate-500) 10%, transparent);
      }
    }
    .hover\\:bg-slate-600:hover {
      background-color: var(--color-slate-600);
    }
    .hover\\:bg-slate-600\\/50:hover {
      background-color: color-mix(in srgb, oklch(44.6% 0.043 257.281) 50%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-600\\/50:hover {
        background-color: color-mix(in oklab, var(--color-slate-600) 50%, transparent);
      }
    }
    .hover\\:bg-slate-600\\/60:hover {
      background-color: color-mix(in srgb, oklch(44.6% 0.043 257.281) 60%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-600\\/60:hover {
        background-color: color-mix(in oklab, var(--color-slate-600) 60%, transparent);
      }
    }
    .hover\\:bg-slate-700:hover {
      background-color: var(--color-slate-700);
    }
    .hover\\:bg-slate-700\\/30:hover {
      background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 30%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-700\\/30:hover {
        background-color: color-mix(in oklab, var(--color-slate-700) 30%, transparent);
      }
    }
    .hover\\:bg-slate-700\\/40:hover {
      background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 40%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-700\\/40:hover {
        background-color: color-mix(in oklab, var(--color-slate-700) 40%, transparent);
      }
    }
    .hover\\:bg-slate-800:hover {
      background-color: var(--color-slate-800);
    }
    .hover\\:bg-slate-800\\/50:hover {
      background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 50%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-800\\/50:hover {
        background-color: color-mix(in oklab, var(--color-slate-800) 50%, transparent);
      }
    }
    .hover\\:bg-slate-800\\/60:hover {
      background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 60%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-800\\/60:hover {
        background-color: color-mix(in oklab, var(--color-slate-800) 60%, transparent);
      }
    }
    .hover\\:bg-slate-800\\/70:hover {
      background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 70%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-800\\/70:hover {
        background-color: color-mix(in oklab, var(--color-slate-800) 70%, transparent);
      }
    }
    .hover\\:bg-slate-800\\/80:hover {
      background-color: color-mix(in srgb, oklch(27.9% 0.041 260.031) 80%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-slate-800\\/80:hover {
        background-color: color-mix(in oklab, var(--color-slate-800) 80%, transparent);
      }
    }
    .hover\\:bg-transparent:hover {
      background-color: transparent;
    }
    .hover\\:bg-yellow-500\\/10:hover {
      background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 10%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-yellow-500\\/10:hover {
        background-color: color-mix(in oklab, var(--color-yellow-500) 10%, transparent);
      }
    }
    .hover\\:bg-yellow-600:hover {
      background-color: var(--color-yellow-600);
    }
    .hover\\:from-amber-600:hover {
      --tw-gradient-from: var(--color-amber-600);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:from-amber-700:hover {
      --tw-gradient-from: var(--color-amber-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:from-emerald-700:hover {
      --tw-gradient-from: var(--color-emerald-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:from-purple-700:hover {
      --tw-gradient-from: var(--color-purple-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:from-rose-700:hover {
      --tw-gradient-from: var(--color-rose-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:from-sky-700:hover {
      --tw-gradient-from: var(--color-sky-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-amber-700:hover {
      --tw-gradient-to: var(--color-amber-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-blue-700:hover {
      --tw-gradient-to: var(--color-blue-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-orange-700:hover {
      --tw-gradient-to: var(--color-orange-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-pink-700:hover {
      --tw-gradient-to: var(--color-pink-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-teal-700:hover {
      --tw-gradient-to: var(--color-teal-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-yellow-600:hover {
      --tw-gradient-to: var(--color-yellow-600);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:to-yellow-700:hover {
      --tw-gradient-to: var(--color-yellow-700);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
    .hover\\:text-\\[color\\:var\\(--mc-cyan\\)\\]:hover {
      color: var(--mc-cyan);
    }
    .hover\\:text-\\[color\\:var\\(--mc-text-hero\\)\\]:hover {
      color: var(--mc-text-hero);
    }
    .hover\\:text-\\[color\\:var\\(--mc-text-primary\\)\\]:hover {
      color: var(--mc-text-primary);
    }
    .hover\\:text-\\[color\\:var\\(--mc-white\\)\\]:hover {
      color: var(--mc-white);
    }
    .hover\\:text-accent-foreground:hover {
      color: var(--accent-foreground);
    }
    .hover\\:text-amber-200:hover {
      color: var(--color-amber-200);
    }
    .hover\\:text-amber-300:hover {
      color: var(--color-amber-300);
    }
    .hover\\:text-amber-400:hover {
      color: var(--color-amber-400);
    }
    .hover\\:text-black:hover {
      color: var(--color-black);
    }
    .hover\\:text-blue-300:hover {
      color: var(--color-blue-300);
    }
    .hover\\:text-blue-700:hover {
      color: var(--color-blue-700);
    }
    .hover\\:text-emerald-300:hover {
      color: var(--color-emerald-300);
    }
    .hover\\:text-foreground:hover {
      color: var(--foreground);
    }
    .hover\\:text-green-300:hover {
      color: var(--color-green-300);
    }
    .hover\\:text-muted-foreground:hover {
      color: var(--muted-foreground);
    }
    .hover\\:text-red-300:hover {
      color: var(--color-red-300);
    }
    .hover\\:text-sidebar-accent-foreground:hover {
      color: var(--sidebar-accent-foreground);
    }
    .hover\\:text-slate-200:hover {
      color: var(--color-slate-200);
    }
    .hover\\:text-slate-300:hover {
      color: var(--color-slate-300);
    }
    .hover\\:text-slate-900:hover {
      color: var(--color-slate-900);
    }
    .hover\\:text-white:hover {
      color: var(--color-white);
    }
    .hover\\:no-underline:hover {
      text-decoration-line: none;
    }
    .hover\\:underline:hover {
      text-decoration-line: underline;
    }
    .hover\\:opacity-80:hover {
      opacity: 80%;
    }
    .hover\\:opacity-90:hover {
      opacity: 90%;
    }
    .hover\\:opacity-100:hover {
      opacity: 100%;
    }
    .hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover {
      --tw-shadow: 0 0 0 1px var(--tw-shadow-color, hsl(var(--sidebar-accent)));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    .hover\\:shadow-xl:hover {
      --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    .hover\\:ring-4:hover {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    .hover\\:shadow-slate-900\\/50:hover {
      --tw-shadow-color: color-mix(in srgb, oklch(20.8% 0.042 265.755) 50%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:shadow-slate-900\\/50:hover {
        --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-slate-900) 50%, transparent) var(--tw-shadow-alpha), transparent);
      }
    }
    .hover\\:brightness-125:hover {
      --tw-brightness: brightness(125%);
      filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
    }
    .hover\\:group-data-\\[collapsible\\=offcanvas\\]\\:bg-sidebar:hover:is(:where(.group)[data-collapsible="offcanvas"] *) {
      background-color: var(--sidebar);
    }
    .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:is(:where(.group):is(.destructive) *):hover {
      border-color: var(--destructive);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:is(:where(.group):is(.destructive) *):hover {
        border-color: color-mix(in oklab, var(--destructive) 30%, transparent);
      }
    }
    .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:is(:where(.group):is(.destructive) *):hover {
      background-color: var(--destructive);
    }
    .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:is(:where(.group):is(.destructive) *):hover {
      color: var(--destructive-foreground);
    }
    .group-\\[\\.destructive\\]\\:hover\\:text-red-50:is(:where(.group):is(.destructive) *):hover {
      color: var(--color-red-50);
    }
    .hover\\:after\\:bg-sidebar-border:hover::after {
      content: var(--tw-content);
      background-color: var(--sidebar-border);
    }
  }
  .focus\\:z-10:focus {
    z-index: 10;
  }
  .focus\\:border-amber-500:focus {
    border-color: var(--color-amber-500);
  }
  .focus\\:border-blue-500:focus {
    border-color: var(--color-blue-500);
  }
  .focus\\:border-red-500:focus {
    border-color: var(--color-red-500);
  }
  .focus\\:bg-accent:focus {
    background-color: var(--accent);
  }
  .focus\\:bg-amber-500:focus {
    background-color: var(--color-amber-500);
  }
  .focus\\:text-accent-foreground:focus {
    color: var(--accent-foreground);
  }
  .focus\\:text-slate-900:focus {
    color: var(--color-slate-900);
  }
  .focus\\:opacity-100:focus {
    opacity: 100%;
  }
  .focus\\:ring-1:focus {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus\\:ring-2:focus {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus\\:ring-amber-400:focus {
    --tw-ring-color: var(--color-amber-400);
  }
  .focus\\:ring-amber-500:focus {
    --tw-ring-color: var(--color-amber-500);
  }
  .focus\\:ring-amber-500\\/50:focus {
    --tw-ring-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-amber-500) 50%, transparent);
    }
  }
  .focus\\:ring-red-500\\/50:focus {
    --tw-ring-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-red-500) 50%, transparent);
    }
  }
  .focus\\:ring-ring:focus {
    --tw-ring-color: var(--ring);
  }
  .focus\\:ring-offset-2:focus {
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus\\:outline-hidden:focus {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .focus\\:outline-none:focus {
    --tw-outline-style: none;
    outline-style: none;
  }
  .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:is(:where(.group):is(.destructive) *):focus {
    --tw-ring-color: var(--destructive);
  }
  .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:is(:where(.group):is(.destructive) *):focus {
    --tw-ring-color: var(--color-red-400);
  }
  .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:is(:where(.group):is(.destructive) *):focus {
    --tw-ring-offset-color: var(--color-red-600);
  }
  .focus-visible\\:z-10:focus-visible {
    z-index: 10;
  }
  .focus-visible\\:border-ring:focus-visible {
    border-color: var(--ring);
  }
  .focus-visible\\:bg-\\[color\\:var\\(--mc-bg-raised\\)\\]:focus-visible {
    background-color: var(--mc-bg-raised);
  }
  .focus-visible\\:bg-\\[color\\:var\\(--mc-surface-raised\\)\\]:focus-visible {
    background-color: var(--mc-surface-raised);
  }
  .focus-visible\\:bg-\\[rgba\\(29\\,224\\,197\\,0\\.08\\)\\]:focus-visible {
    background-color: rgba(29,224,197,0.08);
  }
  .focus-visible\\:ring-1:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-visible\\:ring-2:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-visible\\:ring-4:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-visible\\:ring-\\[3px\\]:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-visible\\:ring-\\[color\\:var\\(--mc-cyan\\)\\]:focus-visible {
    --tw-ring-color: var(--mc-cyan);
  }
  .focus-visible\\:ring-destructive\\/20:focus-visible {
    --tw-ring-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 20%, transparent);
    }
  }
  .focus-visible\\:ring-ring:focus-visible {
    --tw-ring-color: var(--ring);
  }
  .focus-visible\\:ring-ring\\/50:focus-visible {
    --tw-ring-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  .focus-visible\\:ring-offset-1:focus-visible {
    --tw-ring-offset-width: 1px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus-visible\\:outline-hidden:focus-visible {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .focus-visible\\:outline-1:focus-visible {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .focus-visible\\:outline-ring:focus-visible {
    outline-color: var(--ring);
  }
  .active\\:bg-sidebar-accent:active {
    background-color: var(--sidebar-accent);
  }
  .active\\:bg-slate-500:active {
    background-color: var(--color-slate-500);
  }
  .active\\:text-sidebar-accent-foreground:active {
    color: var(--sidebar-accent-foreground);
  }
  .disabled\\:pointer-events-none:disabled {
    pointer-events: none;
  }
  .disabled\\:cursor-default:disabled {
    cursor: default;
  }
  .disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
  }
  .disabled\\:opacity-40:disabled {
    opacity: 40%;
  }
  .disabled\\:opacity-50:disabled {
    opacity: 50%;
  }
  :where([data-side="left"]) .in-data-\\[side\\=left\\]\\:cursor-w-resize {
    cursor: w-resize;
  }
  :where([data-side="right"]) .in-data-\\[side\\=right\\]\\:cursor-e-resize {
    cursor: e-resize;
  }
  .has-focus\\:border-ring:has(:focus) {
    border-color: var(--ring);
  }
  .has-focus\\:ring-\\[3px\\]:has(:focus) {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .has-focus\\:ring-ring\\/50:has(:focus) {
    --tw-ring-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  .has-disabled\\:opacity-50:has(:disabled) {
    opacity: 50%;
  }
  .has-data-\\[slot\\=card-action\\]\\:grid-cols-\\[1fr_auto\\]:has([data-slot="card-action"]) {
    grid-template-columns: 1fr auto;
  }
  .has-data-\\[variant\\=inset\\]\\:bg-sidebar:has([data-variant="inset"]) {
    background-color: var(--sidebar);
  }
  .has-\\[\\>svg\\]\\:grid-cols-\\[calc\\(var\\(--spacing\\)\\*4\\)_1fr\\]:has( > svg) {
    grid-template-columns: calc(var(--spacing) * 4) 1fr;
  }
  .has-\\[\\>svg\\]\\:gap-x-3:has( > svg) {
    column-gap: calc(var(--spacing) * 3);
  }
  .has-\\[\\>svg\\]\\:px-2\\.5:has( > svg) {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .has-\\[\\>svg\\]\\:px-3:has( > svg) {
    padding-inline: calc(var(--spacing) * 3);
  }
  .has-\\[\\>svg\\]\\:px-4:has( > svg) {
    padding-inline: calc(var(--spacing) * 4);
  }
  .aria-disabled\\:pointer-events-none[aria-disabled="true"] {
    pointer-events: none;
  }
  .aria-disabled\\:opacity-50[aria-disabled="true"] {
    opacity: 50%;
  }
  .aria-invalid\\:border-destructive[aria-invalid="true"] {
    border-color: var(--destructive);
  }
  .aria-invalid\\:ring-destructive\\/20[aria-invalid="true"] {
    --tw-ring-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 20%, transparent);
    }
  }
  .aria-selected\\:bg-slate-700[aria-selected="true"] {
    background-color: var(--color-slate-700);
  }
  .aria-selected\\:text-muted-foreground[aria-selected="true"] {
    color: var(--muted-foreground);
  }
  .aria-selected\\:text-white[aria-selected="true"] {
    color: var(--color-white);
  }
  .data-\\[active\\=true\\]\\:z-10[data-active="true"] {
    z-index: 10;
  }
  .data-\\[active\\=true\\]\\:border-ring[data-active="true"] {
    border-color: var(--ring);
  }
  .data-\\[active\\=true\\]\\:bg-accent\\/50[data-active="true"] {
    background-color: var(--accent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--accent) 50%, transparent);
    }
  }
  .data-\\[active\\=true\\]\\:bg-sidebar-accent[data-active="true"] {
    background-color: var(--sidebar-accent);
  }
  .data-\\[active\\=true\\]\\:font-medium[data-active="true"] {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .data-\\[active\\=true\\]\\:text-accent-foreground[data-active="true"] {
    color: var(--accent-foreground);
  }
  .data-\\[active\\=true\\]\\:text-sidebar-accent-foreground[data-active="true"] {
    color: var(--sidebar-accent-foreground);
  }
  .data-\\[active\\=true\\]\\:ring-\\[3px\\][data-active="true"] {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .data-\\[active\\=true\\]\\:ring-ring\\/50[data-active="true"] {
    --tw-ring-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  @media (hover: hover) {
    .data-\\[active\\=true\\]\\:hover\\:bg-accent[data-active="true"]:hover {
      background-color: var(--accent);
    }
  }
  .data-\\[active\\=true\\]\\:focus\\:bg-accent[data-active="true"]:focus {
    background-color: var(--accent);
  }
  .data-\\[active\\=true\\]\\:aria-invalid\\:border-destructive[data-active="true"][aria-invalid="true"] {
    border-color: var(--destructive);
  }
  .data-\\[active\\=true\\]\\:aria-invalid\\:ring-destructive\\/20[data-active="true"][aria-invalid="true"] {
    --tw-ring-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 20%, transparent);
    }
  }
  .data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
    pointer-events: none;
  }
  .data-\\[disabled\\]\\:opacity-50[data-disabled] {
    opacity: 50%;
  }
  .data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
    pointer-events: none;
  }
  .data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
    opacity: 50%;
  }
  .data-\\[error\\=true\\]\\:text-destructive[data-error="true"] {
    color: var(--destructive);
  }
  .data-\\[inset\\]\\:pl-8[data-inset] {
    padding-left: calc(var(--spacing) * 8);
  }
  .data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
    --tw-enter-translate-x: calc(52*var(--spacing));
  }
  .data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
    --tw-enter-translate-x: calc(52*var(--spacing)*-1);
  }
  .data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
    --tw-exit-translate-x: calc(52*var(--spacing));
  }
  .data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
    --tw-exit-translate-x: calc(52*var(--spacing)*-1);
  }
  .data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
    animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
    --tw-enter-opacity: 0;
  }
  .data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
    animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
    --tw-exit-opacity: 0;
  }
  .data-\\[orientation\\=horizontal\\]\\:h-1\\.5[data-orientation="horizontal"] {
    height: calc(var(--spacing) * 1.5);
  }
  .data-\\[orientation\\=horizontal\\]\\:h-full[data-orientation="horizontal"] {
    height: 100%;
  }
  .data-\\[orientation\\=horizontal\\]\\:h-px[data-orientation="horizontal"] {
    height: 1px;
  }
  .data-\\[orientation\\=horizontal\\]\\:w-full[data-orientation="horizontal"] {
    width: 100%;
  }
  .data-\\[orientation\\=vertical\\]\\:h-full[data-orientation="vertical"] {
    height: 100%;
  }
  .data-\\[orientation\\=vertical\\]\\:min-h-44[data-orientation="vertical"] {
    min-height: calc(var(--spacing) * 44);
  }
  .data-\\[orientation\\=vertical\\]\\:w-1\\.5[data-orientation="vertical"] {
    width: calc(var(--spacing) * 1.5);
  }
  .data-\\[orientation\\=vertical\\]\\:w-auto[data-orientation="vertical"] {
    width: auto;
  }
  .data-\\[orientation\\=vertical\\]\\:w-full[data-orientation="vertical"] {
    width: 100%;
  }
  .data-\\[orientation\\=vertical\\]\\:w-px[data-orientation="vertical"] {
    width: 1px;
  }
  .data-\\[orientation\\=vertical\\]\\:flex-col[data-orientation="vertical"] {
    flex-direction: column;
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
    height: 1px;
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
    width: 100%;
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
    flex-direction: column;
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content);
    left: 0px;
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content);
    height: var(--spacing);
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content);
    width: 100%;
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content);
    --tw-translate-x: 0px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content);
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder] {
    color: var(--muted-foreground);
  }
  .data-\\[range-end\\=true\\]\\:rounded-md[data-range-end="true"] {
    border-radius: calc(var(--radius) - 2px);
  }
  .data-\\[range-end\\=true\\]\\:rounded-r-md[data-range-end="true"] {
    border-top-right-radius: calc(var(--radius) - 2px);
    border-bottom-right-radius: calc(var(--radius) - 2px);
  }
  .data-\\[range-end\\=true\\]\\:bg-primary[data-range-end="true"] {
    background-color: var(--primary);
  }
  .data-\\[range-end\\=true\\]\\:text-primary-foreground[data-range-end="true"] {
    color: var(--primary-foreground);
  }
  .data-\\[range-middle\\=true\\]\\:rounded-none[data-range-middle="true"] {
    border-radius: 0;
  }
  .data-\\[range-middle\\=true\\]\\:bg-accent[data-range-middle="true"] {
    background-color: var(--accent);
  }
  .data-\\[range-middle\\=true\\]\\:text-accent-foreground[data-range-middle="true"] {
    color: var(--accent-foreground);
  }
  .data-\\[range-start\\=true\\]\\:rounded-md[data-range-start="true"] {
    border-radius: calc(var(--radius) - 2px);
  }
  .data-\\[range-start\\=true\\]\\:rounded-l-md[data-range-start="true"] {
    border-top-left-radius: calc(var(--radius) - 2px);
    border-bottom-left-radius: calc(var(--radius) - 2px);
  }
  .data-\\[range-start\\=true\\]\\:bg-primary[data-range-start="true"] {
    background-color: var(--primary);
  }
  .data-\\[range-start\\=true\\]\\:text-primary-foreground[data-range-start="true"] {
    color: var(--primary-foreground);
  }
  .data-\\[selected-single\\=true\\]\\:bg-primary[data-selected-single="true"] {
    background-color: var(--primary);
  }
  .data-\\[selected-single\\=true\\]\\:text-primary-foreground[data-selected-single="true"] {
    color: var(--primary-foreground);
  }
  .data-\\[selected\\=true\\]\\:rounded-none[data-selected="true"] {
    border-radius: 0;
  }
  .data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"] {
    background-color: var(--accent);
  }
  .data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
    color: var(--accent-foreground);
  }
  .data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
    --tw-translate-y: var(--spacing);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
    --tw-enter-translate-y: calc(2*var(--spacing)*-1);
  }
  .data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
    --tw-translate-x: calc(var(--spacing) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
    --tw-enter-translate-x: calc(2*var(--spacing));
  }
  .data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
    --tw-translate-x: var(--spacing);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
    --tw-enter-translate-x: calc(2*var(--spacing)*-1);
  }
  .data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
    --tw-translate-y: calc(var(--spacing) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
    --tw-enter-translate-y: calc(2*var(--spacing));
  }
  .data-\\[size\\=default\\]\\:h-9[data-size="default"] {
    height: calc(var(--spacing) * 9);
  }
  .data-\\[size\\=sm\\]\\:h-8[data-size="sm"] {
    height: calc(var(--spacing) * 8);
  }
  :is(.\\*\\:data-\\[slot\\=alert-description\\]\\:text-destructive\\/90 > *)[data-slot="alert-description"] {
    color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--destructive) 90%, transparent);
    }
  }
  :is(.\\*\\*\\:data-\\[slot\\=command-input-wrapper\\]\\:h-12 *)[data-slot="command-input-wrapper"] {
    height: calc(var(--spacing) * 12);
  }
  :is(.\\*\\*\\:data-\\[slot\\=navigation-menu-link\\]\\:focus\\:ring-0 *)[data-slot="navigation-menu-link"]:focus {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  :is(.\\*\\*\\:data-\\[slot\\=navigation-menu-link\\]\\:focus\\:outline-none *)[data-slot="navigation-menu-link"]:focus {
    --tw-outline-style: none;
    outline-style: none;
  }
  :is(.\\*\\:data-\\[slot\\=select-value\\]\\:line-clamp-1 > *)[data-slot="select-value"] {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  :is(.\\*\\:data-\\[slot\\=select-value\\]\\:flex > *)[data-slot="select-value"] {
    display: flex;
  }
  :is(.\\*\\:data-\\[slot\\=select-value\\]\\:items-center > *)[data-slot="select-value"] {
    align-items: center;
  }
  :is(.\\*\\:data-\\[slot\\=select-value\\]\\:gap-2 > *)[data-slot="select-value"] {
    gap: calc(var(--spacing) * 2);
  }
  .data-\\[state\\=active\\]\\:bg-amber-500[data-state="active"] {
    background-color: var(--color-amber-500);
  }
  .data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
    background-color: var(--background);
  }
  .data-\\[state\\=active\\]\\:text-black[data-state="active"] {
    color: var(--color-black);
  }
  .data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .data-\\[state\\=checked\\]\\:translate-x-\\[calc\\(100\\%-2px\\)\\][data-state="checked"] {
    --tw-translate-x: calc(100% - 2px);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[state\\=checked\\]\\:border-primary[data-state="checked"] {
    border-color: var(--primary);
  }
  .data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
    background-color: var(--primary);
  }
  .data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
    color: var(--primary-foreground);
  }
  .data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
    animation: accordion-up var(--tw-animation-duration,var(--tw-duration,.2s))ease-out;
  }
  .data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
    animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
    --tw-exit-opacity: calc(0/100);
    --tw-exit-opacity: 0;
  }
  .data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
    --tw-exit-opacity: calc(80/100);
    --tw-exit-opacity: .8;
  }
  .data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
    --tw-exit-scale: calc(95*1%);
    --tw-exit-scale: .95;
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
    --tw-exit-translate-y: 100%;
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
    --tw-exit-translate-x: -100%;
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
    --tw-exit-translate-x: 100%;
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
    --tw-exit-translate-x: calc(1*100%);
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
    --tw-exit-translate-y: -100%;
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top-4[data-state="closed"] {
    --tw-exit-translate-y: calc(4*var(--spacing)*-1);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:animate-out:is(:where(.group\\/navigation-menu)[data-viewport="false"] *)[data-state="closed"] {
    animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:fade-out-0:is(:where(.group\\/navigation-menu)[data-viewport="false"] *)[data-state="closed"] {
    --tw-exit-opacity: calc(0/100);
    --tw-exit-opacity: 0;
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:zoom-out-95:is(:where(.group\\/navigation-menu)[data-viewport="false"] *)[data-state="closed"] {
    --tw-exit-scale: calc(95*1%);
    --tw-exit-scale: .95;
  }
  .data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
    animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
    --tw-exit-opacity: 0;
  }
  .data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
    background-color: var(--accent);
  }
  .data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
    color: var(--accent-foreground);
  }
  .data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
    animation: accordion-down var(--tw-animation-duration,var(--tw-duration,.2s))ease-out;
  }
  .data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
    animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
    background-color: var(--accent);
  }
  .data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
    background-color: var(--accent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--accent) 50%, transparent);
    }
  }
  .data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
    background-color: var(--secondary);
  }
  .data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
    color: var(--accent-foreground);
  }
  .data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
    color: var(--muted-foreground);
  }
  .data-\\[state\\=open\\]\\:opacity-100[data-state="open"] {
    opacity: 100%;
  }
  .data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
    --tw-enter-opacity: calc(0/100);
    --tw-enter-opacity: 0;
  }
  .data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
    --tw-enter-scale: calc(90*1%);
    --tw-enter-scale: .9;
  }
  .data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
    --tw-enter-scale: calc(95*1%);
    --tw-enter-scale: .95;
  }
  .data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
    --tw-enter-translate-x: -100%;
  }
  .data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
    --tw-enter-translate-x: 100%;
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
    --tw-enter-translate-y: -100%;
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-4[data-state="open"] {
    --tw-enter-translate-y: calc(4*var(--spacing)*-1);
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
    --tw-enter-translate-y: calc(1*-100%);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:animate-in:is(:where(.group\\/navigation-menu)[data-viewport="false"] *)[data-state="open"] {
    animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:fade-in-0:is(:where(.group\\/navigation-menu)[data-viewport="false"] *)[data-state="open"] {
    --tw-enter-opacity: calc(0/100);
    --tw-enter-opacity: 0;
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:zoom-in-95:is(:where(.group\\/navigation-menu)[data-viewport="false"] *)[data-state="open"] {
    --tw-enter-scale: calc(95*1%);
    --tw-enter-scale: .95;
  }
  @media (hover: hover) {
    .data-\\[state\\=open\\]\\:hover\\:bg-accent[data-state="open"]:hover {
      background-color: var(--accent);
    }
    .data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent[data-state="open"]:hover {
      background-color: var(--sidebar-accent);
    }
    .data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground[data-state="open"]:hover {
      color: var(--sidebar-accent-foreground);
    }
  }
  .data-\\[state\\=open\\]\\:focus\\:bg-accent[data-state="open"]:focus {
    background-color: var(--accent);
  }
  .data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
    background-color: var(--muted);
  }
  .data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
    --tw-translate-x: 0px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
    background-color: var(--input);
  }
  .data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
    animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
    --tw-enter-opacity: 0;
  }
  .data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
    --tw-translate-x: 0px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
    --tw-translate-x: var(--radix-toast-swipe-end-x);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
    animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards);
  }
  .data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
    --tw-translate-x: var(--radix-toast-swipe-move-x);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
    transition-property: none;
  }
  .data-\\[variant\\=destructive\\]\\:text-destructive[data-variant="destructive"] {
    color: var(--destructive);
  }
  .data-\\[variant\\=destructive\\]\\:focus\\:bg-destructive\\/10[data-variant="destructive"]:focus {
    background-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--destructive) 10%, transparent);
    }
  }
  .data-\\[variant\\=destructive\\]\\:focus\\:text-destructive[data-variant="destructive"]:focus {
    color: var(--destructive);
  }
  .data-\\[variant\\=outline\\]\\:border-l-0[data-variant="outline"] {
    border-left-style: var(--tw-border-style);
    border-left-width: 0px;
  }
  .data-\\[variant\\=outline\\]\\:shadow-xs[data-variant="outline"] {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .data-\\[variant\\=outline\\]\\:first\\:border-l[data-variant="outline"]:first-child {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .data-\\[vaul-drawer-direction\\=bottom\\]\\:inset-x-0[data-vaul-drawer-direction="bottom"] {
    inset-inline: 0px;
  }
  .data-\\[vaul-drawer-direction\\=bottom\\]\\:bottom-0[data-vaul-drawer-direction="bottom"] {
    bottom: 0px;
  }
  .data-\\[vaul-drawer-direction\\=bottom\\]\\:mt-24[data-vaul-drawer-direction="bottom"] {
    margin-top: calc(var(--spacing) * 24);
  }
  .data-\\[vaul-drawer-direction\\=bottom\\]\\:max-h-\\[80vh\\][data-vaul-drawer-direction="bottom"] {
    max-height: 80vh;
  }
  .data-\\[vaul-drawer-direction\\=bottom\\]\\:rounded-t-lg[data-vaul-drawer-direction="bottom"] {
    border-top-left-radius: var(--radius);
    border-top-right-radius: var(--radius);
  }
  .data-\\[vaul-drawer-direction\\=bottom\\]\\:border-t[data-vaul-drawer-direction="bottom"] {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .data-\\[vaul-drawer-direction\\=left\\]\\:inset-y-0[data-vaul-drawer-direction="left"] {
    inset-block: 0px;
  }
  .data-\\[vaul-drawer-direction\\=left\\]\\:left-0[data-vaul-drawer-direction="left"] {
    left: 0px;
  }
  .data-\\[vaul-drawer-direction\\=left\\]\\:w-3\\/4[data-vaul-drawer-direction="left"] {
    width: calc(3 / 4 * 100%);
  }
  .data-\\[vaul-drawer-direction\\=left\\]\\:border-r[data-vaul-drawer-direction="left"] {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .data-\\[vaul-drawer-direction\\=right\\]\\:inset-y-0[data-vaul-drawer-direction="right"] {
    inset-block: 0px;
  }
  .data-\\[vaul-drawer-direction\\=right\\]\\:right-0[data-vaul-drawer-direction="right"] {
    right: 0px;
  }
  .data-\\[vaul-drawer-direction\\=right\\]\\:w-3\\/4[data-vaul-drawer-direction="right"] {
    width: calc(3 / 4 * 100%);
  }
  .data-\\[vaul-drawer-direction\\=right\\]\\:border-l[data-vaul-drawer-direction="right"] {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .data-\\[vaul-drawer-direction\\=top\\]\\:inset-x-0[data-vaul-drawer-direction="top"] {
    inset-inline: 0px;
  }
  .data-\\[vaul-drawer-direction\\=top\\]\\:top-0[data-vaul-drawer-direction="top"] {
    top: 0px;
  }
  .data-\\[vaul-drawer-direction\\=top\\]\\:mb-24[data-vaul-drawer-direction="top"] {
    margin-bottom: calc(var(--spacing) * 24);
  }
  .data-\\[vaul-drawer-direction\\=top\\]\\:max-h-\\[80vh\\][data-vaul-drawer-direction="top"] {
    max-height: 80vh;
  }
  .data-\\[vaul-drawer-direction\\=top\\]\\:rounded-b-lg[data-vaul-drawer-direction="top"] {
    border-bottom-right-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
  }
  .data-\\[vaul-drawer-direction\\=top\\]\\:border-b[data-vaul-drawer-direction="top"] {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  @media (width >= 40rem) {
    .sm\\:top-auto {
      top: auto;
    }
    .sm\\:right-0 {
      right: 0px;
    }
    .sm\\:bottom-0 {
      bottom: 0px;
    }
    .sm\\:-mx-6 {
      margin-inline: calc(var(--spacing) * -6);
    }
    .sm\\:mr-2 {
      margin-right: calc(var(--spacing) * 2);
    }
    .sm\\:mb-3 {
      margin-bottom: calc(var(--spacing) * 3);
    }
    .sm\\:block {
      display: block;
    }
    .sm\\:flex {
      display: flex;
    }
    .sm\\:grid {
      display: grid;
    }
    .sm\\:hidden {
      display: none;
    }
    .sm\\:inline {
      display: inline;
    }
    .sm\\:inline-flex {
      display: inline-flex;
    }
    .sm\\:h-16 {
      height: calc(var(--spacing) * 16);
    }
    .sm\\:h-24 {
      height: calc(var(--spacing) * 24);
    }
    .sm\\:\\!w-\\[90vw\\] {
      width: 90vw !important;
    }
    .sm\\:w-36 {
      width: calc(var(--spacing) * 36);
    }
    .sm\\:w-40 {
      width: calc(var(--spacing) * 40);
    }
    .sm\\:w-auto {
      width: auto;
    }
    .sm\\:\\!max-w-\\[90vw\\] {
      max-width: 90vw !important;
    }
    .sm\\:max-w-\\[360px\\] {
      max-width: 360px;
    }
    .sm\\:max-w-\\[520px\\] {
      max-width: 520px;
    }
    .sm\\:max-w-lg {
      max-width: var(--container-lg);
    }
    .sm\\:max-w-md {
      max-width: var(--container-md);
    }
    .sm\\:max-w-sm {
      max-width: var(--container-sm);
    }
    .sm\\:min-w-\\[120px\\] {
      min-width: 120px;
    }
    .sm\\:min-w-\\[200px\\] {
      min-width: 200px;
    }
    .sm\\:flex-none {
      flex: none;
    }
    .sm\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .sm\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .sm\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .sm\\:grid-cols-\\[minmax\\(0\\,1fr\\)_160px\\] {
      grid-template-columns: minmax(0,1fr) 160px;
    }
    .sm\\:grid-cols-\\[minmax\\(0\\,1fr\\)_180px\\] {
      grid-template-columns: minmax(0,1fr) 180px;
    }
    .sm\\:grid-cols-\\[minmax\\(0\\,1fr\\)_auto\\] {
      grid-template-columns: minmax(0,1fr) auto;
    }
    .sm\\:flex-col {
      flex-direction: column;
    }
    .sm\\:flex-row {
      flex-direction: row;
    }
    .sm\\:items-center {
      align-items: center;
    }
    .sm\\:items-end {
      align-items: flex-end;
    }
    .sm\\:justify-between {
      justify-content: space-between;
    }
    .sm\\:justify-end {
      justify-content: flex-end;
    }
    .sm\\:gap-2\\.5 {
      gap: calc(var(--spacing) * 2.5);
    }
    .sm\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .sm\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .sm\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    :where(.sm\\:space-y-0 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    .sm\\:p-5 {
      padding: calc(var(--spacing) * 5);
    }
    .sm\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .sm\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
    .sm\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .sm\\:px-8 {
      padding-inline: calc(var(--spacing) * 8);
    }
    .sm\\:py-4 {
      padding-block: calc(var(--spacing) * 4);
    }
    .sm\\:py-8 {
      padding-block: calc(var(--spacing) * 8);
    }
    .sm\\:py-10 {
      padding-block: calc(var(--spacing) * 10);
    }
    .sm\\:pt-0 {
      padding-top: 0px;
    }
    .sm\\:pr-2\\.5 {
      padding-right: calc(var(--spacing) * 2.5);
    }
    .sm\\:pb-3 {
      padding-bottom: calc(var(--spacing) * 3);
    }
    .sm\\:pb-6 {
      padding-bottom: calc(var(--spacing) * 6);
    }
    .sm\\:pl-2\\.5 {
      padding-left: calc(var(--spacing) * 2.5);
    }
    .sm\\:text-left {
      text-align: left;
    }
    .sm\\:text-right {
      text-align: right;
    }
    .sm\\:text-2xl {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    .sm\\:text-3xl {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
    .sm\\:text-6xl {
      font-size: var(--text-6xl);
      line-height: var(--tw-leading, var(--text-6xl--line-height));
    }
    .sm\\:text-lg {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    .sm\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .sm\\:text-xs {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
    .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
      --tw-enter-translate-y: calc(1*100%);
    }
    .data-\\[vaul-drawer-direction\\=left\\]\\:sm\\:max-w-sm[data-vaul-drawer-direction="left"] {
      max-width: var(--container-sm);
    }
    .data-\\[vaul-drawer-direction\\=right\\]\\:sm\\:max-w-sm[data-vaul-drawer-direction="right"] {
      max-width: var(--container-sm);
    }
  }
  @media (width >= 48rem) {
    .md\\:absolute {
      position: absolute;
    }
    .md\\:block {
      display: block;
    }
    .md\\:flex {
      display: flex;
    }
    .md\\:hidden {
      display: none;
    }
    .md\\:inline {
      display: inline;
    }
    .md\\:table-cell {
      display: table-cell;
    }
    .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
      width: var(--radix-navigation-menu-viewport-width);
    }
    .md\\:w-auto {
      width: auto;
    }
    .md\\:max-w-\\[420px\\] {
      max-width: 420px;
    }
    .md\\:min-w-0 {
      min-width: 0px;
    }
    .md\\:snap-none {
      scroll-snap-type: none;
    }
    .md\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .md\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .md\\:flex-row {
      flex-direction: row;
    }
    .md\\:gap-1\\.5 {
      gap: calc(var(--spacing) * 1.5);
    }
    .md\\:overflow-x-visible {
      overflow-x: visible;
    }
    .md\\:text-left {
      text-align: left;
    }
    .md\\:text-7xl {
      font-size: var(--text-7xl);
      line-height: var(--tw-leading, var(--text-7xl--line-height));
    }
    .md\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .md\\:opacity-0 {
      opacity: 0%;
    }
    .md\\:peer-data-\\[variant\\=inset\\]\\:m-2:is(:where(.peer)[data-variant="inset"] ~ *) {
      margin: calc(var(--spacing) * 2);
    }
    .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0:is(:where(.peer)[data-variant="inset"] ~ *) {
      margin-left: 0px;
    }
    .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl:is(:where(.peer)[data-variant="inset"] ~ *) {
      border-radius: calc(var(--radius) + 4px);
    }
    .md\\:peer-data-\\[variant\\=inset\\]\\:shadow-sm:is(:where(.peer)[data-variant="inset"] ~ *) {
      --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    .md\\:peer-data-\\[variant\\=inset\\]\\:peer-data-\\[state\\=collapsed\\]\\:ml-2:is(:where(.peer)[data-variant="inset"] ~ *):is(:where(.peer)[data-state="collapsed"] ~ *) {
      margin-left: calc(var(--spacing) * 2);
    }
    .md\\:after\\:hidden::after {
      content: var(--tw-content);
      display: none;
    }
  }
  @media (width >= 64rem) {
    .lg\\:sticky {
      position: sticky;
    }
    .lg\\:top-20 {
      top: calc(var(--spacing) * 20);
    }
    .lg\\:col-span-1 {
      grid-column: span 1 / span 1;
    }
    .lg\\:col-span-2 {
      grid-column: span 2 / span 2;
    }
    .lg\\:mx-0 {
      margin-inline: 0px;
    }
    .lg\\:grid {
      display: grid;
    }
    .lg\\:table-cell {
      display: table-cell;
    }
    .lg\\:h-\\[calc\\(100dvh-56px\\)\\] {
      height: calc(100dvh - 56px);
    }
    .lg\\:h-full {
      height: 100%;
    }
    .lg\\:h-screen {
      height: 100vh;
    }
    .lg\\:min-h-0 {
      min-height: 0px;
    }
    .lg\\:w-\\[72px\\] {
      width: 72px;
    }
    .lg\\:w-full {
      width: 100%;
    }
    .lg\\:min-w-0 {
      min-width: 0px;
    }
    .lg\\:min-w-\\[104px\\] {
      min-width: 104px;
    }
    .lg\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .lg\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .lg\\:grid-cols-10 {
      grid-template-columns: repeat(10, minmax(0, 1fr));
    }
    .lg\\:grid-cols-\\[1\\.4fr_1fr_0\\.8fr_0\\.9fr_1fr_0\\.7fr\\] {
      grid-template-columns: 1.4fr 1fr 0.8fr 0.9fr 1fr 0.7fr;
    }
    .lg\\:grid-cols-\\[250px_minmax\\(250px\\,0\\.85fr\\)_minmax\\(0\\,0\\.8fr\\)_minmax\\(0\\,1fr\\)\\] {
      grid-template-columns: 250px minmax(250px,0.85fr) minmax(0,0.8fr) minmax(0,1fr);
    }
    .lg\\:grid-cols-\\[260px_1fr_320px\\] {
      grid-template-columns: 260px 1fr 320px;
    }
    .lg\\:grid-cols-\\[minmax\\(0\\,1fr\\)_380px\\] {
      grid-template-columns: minmax(0,1fr) 380px;
    }
    .lg\\:grid-cols-\\[minmax\\(12rem\\,0\\.8fr\\)_minmax\\(0\\,1\\.45fr\\)\\] {
      grid-template-columns: minmax(12rem,0.8fr) minmax(0,1.45fr);
    }
    .lg\\:grid-rows-\\[auto_minmax\\(0\\,1fr\\)\\] {
      grid-template-rows: auto minmax(0,1fr);
    }
    .lg\\:flex-col {
      flex-direction: column;
    }
    .lg\\:flex-row {
      flex-direction: row;
    }
    .lg\\:items-center {
      align-items: center;
    }
    .lg\\:items-end {
      align-items: flex-end;
    }
    .lg\\:items-stretch {
      align-items: stretch;
    }
    .lg\\:justify-between {
      justify-content: space-between;
    }
    .lg\\:self-start {
      align-self: flex-start;
    }
    .lg\\:overflow-hidden {
      overflow: hidden;
    }
    .lg\\:px-0 {
      padding-inline: 0px;
    }
    .lg\\:px-8 {
      padding-inline: calc(var(--spacing) * 8);
    }
    .lg\\:py-3 {
      padding-block: calc(var(--spacing) * 3);
    }
    .lg\\:py-32 {
      padding-block: calc(var(--spacing) * 32);
    }
  }
  @media (width >= 80rem) {
    .xl\\:sticky {
      position: sticky;
    }
    .xl\\:top-3 {
      top: calc(var(--spacing) * 3);
    }
    .xl\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .xl\\:grid-cols-\\[280px_minmax\\(0\\,1fr\\)_340px\\] {
      grid-template-columns: 280px minmax(0,1fr) 340px;
    }
    .xl\\:flex-row {
      flex-direction: row;
    }
    .xl\\:items-center {
      align-items: center;
    }
    .xl\\:justify-between {
      justify-content: space-between;
    }
  }
  @media (width >= 96rem) {
    .\\32 xl\\:flex {
      display: flex;
    }
    .\\32 xl\\:max-w-none {
      max-width: none;
    }
    .\\32 xl\\:grid-cols-\\[minmax\\(0\\,1fr\\)_320px\\] {
      grid-template-columns: minmax(0,1fr) 320px;
    }
    .\\32 xl\\:px-0 {
      padding-inline: 0px;
    }
    .\\32 xl\\:pr-\\[244px\\] {
      padding-right: 244px;
    }
    .\\32 xl\\:pl-\\[224px\\] {
      padding-left: 224px;
    }
  }
  .dark\\:border-input:is(.dark *) {
    border-color: var(--input);
  }
  .dark\\:bg-destructive\\/60:is(.dark *) {
    background-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--destructive) 60%, transparent);
    }
  }
  .dark\\:bg-input\\/30:is(.dark *) {
    background-color: var(--input);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--input) 30%, transparent);
    }
  }
  .dark\\:text-muted-foreground:is(.dark *) {
    color: var(--muted-foreground);
  }
  @media (hover: hover) {
    .dark\\:hover\\:bg-accent\\/50:is(.dark *):hover {
      background-color: var(--accent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .dark\\:hover\\:bg-accent\\/50:is(.dark *):hover {
        background-color: color-mix(in oklab, var(--accent) 50%, transparent);
      }
    }
    .dark\\:hover\\:bg-input\\/50:is(.dark *):hover {
      background-color: var(--input);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .dark\\:hover\\:bg-input\\/50:is(.dark *):hover {
        background-color: color-mix(in oklab, var(--input) 50%, transparent);
      }
    }
    .dark\\:hover\\:text-accent-foreground:is(.dark *):hover {
      color: var(--accent-foreground);
    }
  }
  .dark\\:focus-visible\\:ring-destructive\\/40:is(.dark *):focus-visible {
    --tw-ring-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 40%, transparent);
    }
  }
  .dark\\:aria-invalid\\:ring-destructive\\/40:is(.dark *)[aria-invalid="true"] {
    --tw-ring-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 40%, transparent);
    }
  }
  .dark\\:data-\\[active\\=true\\]\\:aria-invalid\\:ring-destructive\\/40:is(.dark *)[data-active="true"][aria-invalid="true"] {
    --tw-ring-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 40%, transparent);
    }
  }
  .dark\\:data-\\[state\\=active\\]\\:border-input:is(.dark *)[data-state="active"] {
    border-color: var(--input);
  }
  .dark\\:data-\\[state\\=active\\]\\:bg-input\\/30:is(.dark *)[data-state="active"] {
    background-color: var(--input);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--input) 30%, transparent);
    }
  }
  .dark\\:data-\\[state\\=active\\]\\:text-foreground:is(.dark *)[data-state="active"] {
    color: var(--foreground);
  }
  .dark\\:data-\\[state\\=checked\\]\\:bg-primary:is(.dark *)[data-state="checked"] {
    background-color: var(--primary);
  }
  .dark\\:data-\\[state\\=checked\\]\\:bg-primary-foreground:is(.dark *)[data-state="checked"] {
    background-color: var(--primary-foreground);
  }
  .dark\\:data-\\[state\\=unchecked\\]\\:bg-foreground:is(.dark *)[data-state="unchecked"] {
    background-color: var(--foreground);
  }
  .dark\\:data-\\[state\\=unchecked\\]\\:bg-input\\/80:is(.dark *)[data-state="unchecked"] {
    background-color: var(--input);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--input) 80%, transparent);
    }
  }
  .dark\\:data-\\[variant\\=destructive\\]\\:focus\\:bg-destructive\\/20:is(.dark *)[data-variant="destructive"]:focus {
    background-color: var(--destructive);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--destructive) 20%, transparent);
    }
  }
  .\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text {
    fill: var(--muted-foreground);
  }
  .\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc'] {
    stroke: var(--border);
    @supports (color: color-mix(in lab, red, red)) {
      stroke: color-mix(in oklab, var(--border) 50%, transparent);
    }
  }
  .\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor {
    stroke: var(--border);
  }
  .\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff'] {
    stroke: transparent;
  }
  .\\[\\&_\\.recharts-layer\\]\\:outline-hidden .recharts-layer {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc'] {
    stroke: var(--border);
  }
  .\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector {
    fill: var(--muted);
  }
  .\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor {
    fill: var(--muted);
  }
  .\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc'] {
    stroke: var(--border);
  }
  .\\[\\&_\\.recharts-sector\\]\\:outline-hidden .recharts-sector {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff'] {
    stroke: transparent;
  }
  .\\[\\&_\\.recharts-surface\\]\\:outline-hidden .recharts-surface {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
    padding-inline: calc(var(--spacing) * 2);
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
    color: var(--muted-foreground);
  }
  .\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
    padding-inline: calc(var(--spacing) * 2);
  }
  .\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~ [cmdk-group] {
    padding-top: 0px;
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
    height: calc(var(--spacing) * 5);
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
    width: calc(var(--spacing) * 5);
  }
  .\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
    height: calc(var(--spacing) * 12);
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
    padding-inline: calc(var(--spacing) * 2);
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
    padding-block: calc(var(--spacing) * 3);
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
    height: calc(var(--spacing) * 5);
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
    width: calc(var(--spacing) * 5);
  }
  .\\[\\&_input\\]\\:border-slate-600 input {
    border-color: var(--color-slate-600);
  }
  .\\[\\&_input\\]\\:bg-slate-700\\/50 input {
    background-color: color-mix(in srgb, oklch(37.2% 0.044 257.287) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-700) 50%, transparent);
    }
  }
  .\\[\\&_input\\]\\:text-white input {
    color: var(--color-white);
  }
  .\\[\\&_label\\]\\:text-slate-300 label {
    color: var(--color-slate-300);
  }
  .\\[\\&_p\\]\\:leading-relaxed p {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .\\[\\&_svg\\]\\:pointer-events-none svg {
    pointer-events: none;
  }
  .\\[\\&_svg\\]\\:shrink-0 svg {
    flex-shrink: 0;
  }
  .\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-4 svg:not([class*='size-']) {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .\\[\\&_svg\\:not\\(\\[class\\*\\=\\'text-\\'\\]\\)\\]\\:text-muted-foreground svg:not([class*='text-']) {
    color: var(--muted-foreground);
  }
  .\\[\\&_tr\\]\\:border-b tr {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .\\[\\&\\:first-child\\[data-selected\\=true\\]_button\\]\\:rounded-l-md:first-child[data-selected=true] button {
    border-top-left-radius: calc(var(--radius) - 2px);
    border-bottom-left-radius: calc(var(--radius) - 2px);
  }
  .\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
    padding-right: 0px;
  }
  .\\[\\.border-b\\]\\:pb-6:is(.border-b) {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .\\[\\.border-t\\]\\:pt-6:is(.border-t) {
    padding-top: calc(var(--spacing) * 6);
  }
  :is(.rtl\\:\\*\\*\\:\\[\\.rdp-button\\\\_next\\>svg\\]\\:rotate-180:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) *):is(.rdp-button_next > svg) {
    rotate: 180deg;
  }
  :is(.rtl\\:\\*\\*\\:\\[\\.rdp-button\\\\_previous\\>svg\\]\\:rotate-180:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) *):is(.rdp-button_previous > svg) {
    rotate: 180deg;
  }
  :is(.\\*\\:\\[span\\]\\:last\\:flex > *):is(span):last-child {
    display: flex;
  }
  :is(.\\*\\:\\[span\\]\\:last\\:items-center > *):is(span):last-child {
    align-items: center;
  }
  :is(.\\*\\:\\[span\\]\\:last\\:gap-2 > *):is(span):last-child {
    gap: calc(var(--spacing) * 2);
  }
  :is(.data-\\[variant\\=destructive\\]\\:\\*\\:\\[svg\\]\\:\\!text-destructive[data-variant="destructive"] > *):is(svg) {
    color: var(--destructive) !important;
  }
  .\\[\\&\\:last-child\\[data-selected\\=true\\]_button\\]\\:rounded-r-md:last-child[data-selected=true] button {
    border-top-right-radius: calc(var(--radius) - 2px);
    border-bottom-right-radius: calc(var(--radius) - 2px);
  }
  .\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\] > [role=checkbox] {
    --tw-translate-y: 2px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .\\[\\&\\>button\\]\\:hidden > button {
    display: none;
  }
  .\\[\\&\\>span\\]\\:text-xs > span {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .\\[\\&\\>span\\]\\:opacity-70 > span {
    opacity: 70%;
  }
  .\\[\\&\\>span\\:last-child\\]\\:truncate > span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .\\[\\&\\>svg\\]\\:pointer-events-none > svg {
    pointer-events: none;
  }
  .\\[\\&\\>svg\\]\\:size-3 > svg {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
  }
  .\\[\\&\\>svg\\]\\:size-3\\.5 > svg {
    width: calc(var(--spacing) * 3.5);
    height: calc(var(--spacing) * 3.5);
  }
  .\\[\\&\\>svg\\]\\:size-4 > svg {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .\\[\\&\\>svg\\]\\:h-2\\.5 > svg {
    height: calc(var(--spacing) * 2.5);
  }
  .\\[\\&\\>svg\\]\\:h-3 > svg {
    height: calc(var(--spacing) * 3);
  }
  .\\[\\&\\>svg\\]\\:w-2\\.5 > svg {
    width: calc(var(--spacing) * 2.5);
  }
  .\\[\\&\\>svg\\]\\:w-3 > svg {
    width: calc(var(--spacing) * 3);
  }
  .\\[\\&\\>svg\\]\\:shrink-0 > svg {
    flex-shrink: 0;
  }
  .\\[\\&\\>svg\\]\\:translate-y-0\\.5 > svg {
    --tw-translate-y: calc(var(--spacing) * 0.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .\\[\\&\\>svg\\]\\:text-current > svg {
    color: currentcolor;
  }
  .\\[\\&\\>svg\\]\\:text-muted-foreground > svg {
    color: var(--muted-foreground);
  }
  .\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground > svg {
    color: var(--sidebar-accent-foreground);
  }
  .\\[\\&\\>tr\\]\\:last\\:border-b-0 > tr:last-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical] > div {
    rotate: 90deg;
  }
  .\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open] > svg {
    rotate: 180deg;
  }
  [data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2 {
    right: calc(var(--spacing) * -2);
  }
  [data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize {
    cursor: e-resize;
  }
  [data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2 {
    left: calc(var(--spacing) * -2);
  }
  [data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize {
    cursor: w-resize;
  }
  [data-slot=card-content] .\\[\\[data-slot\\=card-content\\]_\\&\\]\\:bg-transparent {
    background-color: transparent;
  }
  [data-slot=popover-content] .\\[\\[data-slot\\=popover-content\\]_\\&\\]\\:bg-transparent {
    background-color: transparent;
  }
  @media (hover: hover) {
    a.\\[a\\&\\]\\:hover\\:bg-accent:hover {
      background-color: var(--accent);
    }
    a.\\[a\\&\\]\\:hover\\:bg-destructive\\/90:hover {
      background-color: var(--destructive);
    }
    @supports (color: color-mix(in lab, red, red)) {
      a.\\[a\\&\\]\\:hover\\:bg-destructive\\/90:hover {
        background-color: color-mix(in oklab, var(--destructive) 90%, transparent);
      }
    }
    a.\\[a\\&\\]\\:hover\\:bg-primary\\/90:hover {
      background-color: var(--primary);
    }
    @supports (color: color-mix(in lab, red, red)) {
      a.\\[a\\&\\]\\:hover\\:bg-primary\\/90:hover {
        background-color: color-mix(in oklab, var(--primary) 90%, transparent);
      }
    }
    a.\\[a\\&\\]\\:hover\\:bg-secondary\\/90:hover {
      background-color: var(--secondary);
    }
    @supports (color: color-mix(in lab, red, red)) {
      a.\\[a\\&\\]\\:hover\\:bg-secondary\\/90:hover {
        background-color: color-mix(in oklab, var(--secondary) 90%, transparent);
      }
    }
    a.\\[a\\&\\]\\:hover\\:text-accent-foreground:hover {
      color: var(--accent-foreground);
    }
  }
}
@property --tw-animation-delay {
  syntax: "*";
  inherits: false;
  initial-value: 0s;
}
@property --tw-animation-direction {
  syntax: "*";
  inherits: false;
  initial-value: normal;
}
@property --tw-animation-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-animation-fill-mode {
  syntax: "*";
  inherits: false;
  initial-value: forwards;
}
@property --tw-animation-iteration-count {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
:root {
  --background: oklch(1 0 0);
  --foreground: oklch(0.145 0 0);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.145 0 0);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: oklch(0.205 0 0);
  --primary-foreground: oklch(0.985 0 0);
  --secondary: oklch(0.97 0 0);
  --secondary-foreground: oklch(0.205 0 0);
  --muted: oklch(0.97 0 0);
  --muted-foreground: oklch(0.556 0 0);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --destructive-foreground: oklch(0.577 0.245 27.325);
  --border: oklch(0.922 0 0);
  --input: oklch(0.922 0 0);
  --ring: oklch(0.708 0 0);
  --chart-1: oklch(0.646 0.222 41.116);
  --chart-2: oklch(0.6 0.118 184.704);
  --chart-3: oklch(0.398 0.07 227.392);
  --chart-4: oklch(0.828 0.189 84.429);
  --chart-5: oklch(0.769 0.188 70.08);
  --radius: 0.625rem;
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: oklch(0.205 0 0);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: oklch(0.708 0 0);
}
.dark {
  --background: oklch(0.145 0 0);
  --foreground: oklch(0.985 0 0);
  --card: oklch(0.145 0 0);
  --card-foreground: oklch(0.985 0 0);
  --popover: oklch(0.145 0 0);
  --popover-foreground: oklch(0.985 0 0);
  --primary: oklch(0.985 0 0);
  --primary-foreground: oklch(0.205 0 0);
  --secondary: oklch(0.269 0 0);
  --secondary-foreground: oklch(0.985 0 0);
  --muted: oklch(0.269 0 0);
  --muted-foreground: oklch(0.708 0 0);
  --accent: oklch(0.269 0 0);
  --accent-foreground: oklch(0.985 0 0);
  --destructive: oklch(0.396 0.141 25.723);
  --destructive-foreground: oklch(0.637 0.237 25.331);
  --border: oklch(0.269 0 0);
  --input: oklch(0.269 0 0);
  --ring: oklch(0.439 0 0);
  --chart-1: oklch(0.488 0.243 264.376);
  --chart-2: oklch(0.696 0.17 162.48);
  --chart-3: oklch(0.769 0.188 70.08);
  --chart-4: oklch(0.627 0.265 303.9);
  --chart-5: oklch(0.645 0.246 16.439);
  --sidebar: oklch(0.205 0 0);
  --sidebar-foreground: oklch(0.985 0 0);
  --sidebar-primary: oklch(0.488 0.243 264.376);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.269 0 0);
  --sidebar-accent-foreground: oklch(0.985 0 0);
  --sidebar-border: oklch(0.269 0 0);
  --sidebar-ring: oklch(0.439 0 0);
  --mc-bg: #06090e;
  --mc-surface: #0e1319;
  --mc-surface-raised: #131a22;
  --mc-cyan: #1de0c5;
  --mc-cyan-dim: #0e9a87;
  --mc-purple: #b855e7;
  --mc-magenta: #f47aa5;
  --mc-white: #e0e5ed;
  --mc-gray: #6a7485;
  --mc-gray-dim: #424a57;
  --mc-divider: #1e2735;
  --mc-divider-soft: #141a24;
  --mc-green: #5fd692;
  --mc-amber: #f59e0b;
  --mc-text-hero: #edf0f5;
  --mc-text-label: #c8d0da;
  --mc-text-primary: #d8dde5;
  --mc-text-meta: #6a7485;
  --mc-text-meta-dim: #424a57;
  --mc-text-accent-teal: #1de0c5;
  --mc-text-accent-pink: #f47aa5;
}
@layer base {
  * {
    border-color: var(--border);
    outline-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      outline-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  body {
    background-color: var(--background);
    color: var(--foreground);
  }
}
:root,
:root[data-ui-theme='classic'],
[data-ui-theme='classic'] {
  --kg-bg: #0f172a;
  --kg-bg-elevated: #111827;
  --kg-surface: #1e293b;
  --kg-surface-raised: #334155;
  --kg-border: #334155;
  --kg-border-soft: rgba(51, 65, 85, 0.7);
  --kg-text: #f8fafc;
  --kg-text-muted: #cbd5e1;
  --kg-text-dim: #94a3b8;
  --kg-accent: #f59e0b;
  --kg-accent-contrast: #0f172a;
  --kg-success: #34d399;
  --kg-danger: #f87171;
  --kg-focus: rgba(245, 158, 11, 0.45);
  --kg-shadow: 0 16px 44px rgba(0, 0, 0, 0.32);
}
:root[data-ui-theme='mission-control'],
[data-ui-theme='mission-control'] {
  --kg-bg: var(--mc-bg, #06090e);
  --kg-bg-elevated: #080c16;
  --kg-surface: var(--mc-surface, #0e1319);
  --kg-surface-raised: var(--mc-surface-raised, #131a22);
  --kg-border: var(--mc-divider, #1e2735);
  --kg-border-soft: var(--mc-divider-soft, #141a24);
  --kg-text: var(--mc-text-primary, #d8dde5);
  --kg-text-muted: var(--mc-text-meta, #6a7485);
  --kg-text-dim: var(--mc-text-meta-dim, #424a57);
  --kg-accent: var(--mc-cyan, #1de0c5);
  --kg-accent-contrast: #06110f;
  --kg-success: var(--mc-green, #5fd692);
  --kg-danger: var(--mc-magenta, #f47aa5);
  --kg-focus: rgba(29, 224, 197, 0.4);
  --kg-shadow: 0 18px 54px rgba(0, 0, 0, 0.46), 0 0 28px rgba(29, 224, 197, 0.08);
}
.kg-theme-root {
  min-height: 100%;
}
.kg-theme-transition,
.kg-page,
.kg-app-header,
.kg-panel,
.kg-dialog,
.kg-popover,
.kg-row,
.kg-input,
.kg-button,
.kg-theme-toggle {
  transition: background-color 160ms ease,
    border-color 160ms ease,
    color 160ms ease,
    box-shadow 160ms ease;
}
.kg-page {
  min-height: 100vh;
  background: var(--kg-bg);
  color: var(--kg-text);
}
.kg-app-header {
  background: var(--kg-bg);
  @supports (color: color-mix(in lab, red, red)) {
    background: color-mix(in srgb, var(--kg-bg) 88%, transparent);
  }
  border-color: var(--kg-border);
  color: var(--kg-text);
}
.kg-panel,
.kg-dialog,
.kg-popover {
  background: var(--kg-surface);
  border: 1px solid var(--kg-border);
  color: var(--kg-text);
  box-shadow: var(--kg-shadow);
}
.kg-panel-raised,
.kg-row {
  background: var(--kg-surface-raised);
  border: 1px solid var(--kg-border-soft);
  color: var(--kg-text);
}
.kg-title {
  color: var(--kg-text);
  font-weight: 600;
}
.kg-meta {
  color: var(--kg-text-muted);
}
.kg-meta-dim {
  color: var(--kg-text-dim);
}
.kg-divider {
  border-color: var(--kg-border-soft);
}
.kg-input {
  background: var(--kg-bg-elevated);
  border: 1px solid var(--kg-border);
  color: var(--kg-text);
}
.kg-input:focus {
  border-color: var(--kg-accent);
  box-shadow: 0 0 0 1px var(--kg-focus);
  outline: none;
}
.kg-button,
.kg-button-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid var(--kg-border);
  color: var(--kg-text);
  background: var(--kg-surface-raised);
}
.kg-button:hover,
.kg-button-secondary:hover {
  border-color: var(--kg-accent);
  color: var(--kg-accent);
}
.kg-button-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid var(--kg-accent);
  color: var(--kg-accent-contrast);
  background: var(--kg-accent);
}
.kg-theme-toggle {
  --kg-toggle-accent: var(--kg-accent);
  --kg-toggle-contrast: var(--kg-accent-contrast);
  position: relative;
  display: inline-flex;
  min-height: 2rem;
  align-items: center;
  gap: 0.45rem;
  border: 1px solid var(--kg-border);
  @supports (color: color-mix(in lab, red, red)) {
    border: 1px solid color-mix(in srgb, var(--kg-border) 70%, var(--kg-toggle-accent));
  }
  border-radius: 999px;
  background: var(--kg-surface);
  @supports (color: color-mix(in lab, red, red)) {
    background: color-mix(in srgb, var(--kg-surface) 82%, transparent);
  }
  color: var(--kg-text-muted);
  cursor: pointer;
  padding: 0.18rem 0.22rem 0.18rem 0.55rem;
  white-space: nowrap;
  box-shadow: inset 0 0 0 1px var(--kg-border-soft);
  @supports (color: color-mix(in lab, red, red)) {
    box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--kg-border-soft) 50%, transparent);
  }
}
.kg-theme-toggle:hover {
  border-color: var(--kg-toggle-accent);
  color: var(--kg-text);
  background: var(--kg-surface-raised);
  @supports (color: color-mix(in lab, red, red)) {
    background: color-mix(in srgb, var(--kg-surface-raised) 88%, transparent);
  }
}
.kg-theme-toggle:focus-visible {
  border-color: var(--kg-toggle-accent);
  box-shadow: 0 0 0 2px var(--kg-focus),
    var(--kg-shadow);
  outline: none;
}
.kg-theme-toggle--full {
  width: 100%;
  justify-content: flex-start;
}
.kg-theme-toggle--full .kg-theme-toggle__track {
  margin-left: auto;
}
.kg-theme-toggle--mc {
  --kg-toggle-accent: var(--mc-cyan, var(--kg-accent));
  --kg-toggle-contrast: #06110f;
  min-height: 1.75rem;
  border-color: rgba(29, 224, 197, 0.28);
  background: rgba(14, 19, 25, 0.72);
  color: var(--mc-text-meta, var(--kg-text-muted));
  padding: 0.12rem 0.18rem 0.12rem 0.42rem;
  box-shadow: none;
}
.kg-theme-toggle--mc:hover {
  background: rgba(19, 26, 34, 0.86);
  color: var(--mc-white, var(--kg-text));
}
.kg-theme-toggle--ghost {
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.kg-theme-toggle--ghost:hover {
  border-color: var(--kg-border);
  background: var(--kg-surface-raised);
  @supports (color: color-mix(in lab, red, red)) {
    background: color-mix(in srgb, var(--kg-surface-raised) 64%, transparent);
  }
}
.kg-theme-toggle__icon {
  display: inline-flex;
  color: var(--kg-toggle-accent);
  flex: 0 0 auto;
}
.kg-theme-toggle__title {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1;
  text-transform: uppercase;
}
.kg-theme-toggle--mc .kg-theme-toggle__title {
  display: none;
}
.kg-theme-toggle--mc.kg-theme-toggle--full .kg-theme-toggle__title {
  display: inline;
}
.kg-theme-toggle__track {
  position: relative;
  display: grid;
  width: 6.25rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  overflow: hidden;
  border: 1px solid var(--kg-border-soft);
  border-radius: 999px;
  background: var(--kg-bg-elevated);
  padding: 0.125rem;
}
.kg-theme-toggle--mc .kg-theme-toggle__track {
  width: 5.75rem;
}
.kg-theme-toggle__thumb {
  position: absolute;
  inset: 0.125rem auto 0.125rem 0.125rem;
  width: calc((100% - 0.25rem) / 2);
  border-radius: 999px;
  background: var(--kg-toggle-accent);
  box-shadow: 0 0 14px var(--kg-toggle-accent);
  @supports (color: color-mix(in lab, red, red)) {
    box-shadow: 0 0 14px color-mix(in srgb, var(--kg-toggle-accent) 34%, transparent);
  }
  transition: transform 180ms ease;
}
.kg-theme-toggle[aria-pressed='true'] .kg-theme-toggle__thumb {
  transform: translateX(100%);
}
.kg-theme-toggle__option {
  position: relative;
  z-index: 1;
  color: var(--kg-text-dim);
  font-size: 0.63rem;
  font-weight: 650;
  line-height: 1.35rem;
  text-align: center;
  transition: color 180ms ease;
}
.kg-theme-toggle:not([aria-pressed='true']) .kg-theme-toggle__option--old,
.kg-theme-toggle[aria-pressed='true'] .kg-theme-toggle__option--new {
  color: var(--kg-toggle-contrast);
}
:root[data-ui-theme='classic'],
[data-ui-theme='classic'],
[data-ui-theme='classic'] .mc-root {
  --mc-bg: #0f172a;
  --mc-surface: rgba(30, 41, 59, 0.82);
  --mc-surface-raised: rgba(51, 65, 85, 0.72);
  --mc-cyan: #f59e0b;
  --mc-cyan-dim: #d97706;
  --mc-purple: #a78bfa;
  --mc-magenta: #fb7185;
  --mc-white: #f8fafc;
  --mc-gray: #cbd5e1;
  --mc-gray-dim: #94a3b8;
  --mc-divider: rgba(148, 163, 184, 0.28);
  --mc-divider-soft: rgba(148, 163, 184, 0.16);
  --mc-green: #34d399;
  --mc-amber: #f59e0b;
  --mc-text-hero: #f8fafc;
  --mc-text-label: #fde68a;
  --mc-text-primary: #e2e8f0;
  --mc-text-meta: #cbd5e1;
  --mc-text-meta-dim: #94a3b8;
  --mc-text-accent-teal: #f59e0b;
  --mc-text-accent-pink: #fb7185;
}
:root[data-ui-theme='mission-control'],
[data-ui-theme='mission-control'],
[data-ui-theme='mission-control'] .mc-root {
  --mc-bg: #06090e;
  --mc-surface: #0e1319;
  --mc-surface-raised: #131a22;
  --mc-cyan: #1de0c5;
  --mc-cyan-dim: #0e9a87;
  --mc-purple: #b855e7;
  --mc-magenta: #f47aa5;
  --mc-white: #e0e5ed;
  --mc-gray: #6a7485;
  --mc-gray-dim: #424a57;
  --mc-divider: #1e2735;
  --mc-divider-soft: #141a24;
  --mc-green: #5fd692;
  --mc-amber: #f59e0b;
  --mc-text-hero: #edf0f5;
  --mc-text-label: #c8d0da;
  --mc-text-primary: #d8dde5;
  --mc-text-meta: #6a7485;
  --mc-text-meta-dim: #424a57;
  --mc-text-accent-teal: #1de0c5;
  --mc-text-accent-pink: #f47aa5;
}
.kg-theme-root .mc-root,
.kg-theme-root .mc-panel,
.kg-theme-root .mc-row {
  transition: background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease,
    box-shadow 180ms ease;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-scroll-snap-strictness {
  syntax: "*";
  inherits: false;
  initial-value: proximity;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity,1);
    transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0));
  }
}
@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity,1);
    transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0));
  }
}
@keyframes accordion-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,auto))));
  }
}
@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,auto))));
  }
  to {
    height: 0;
  }
}
@keyframes caret-blink {
  0%,70%,100% {
    opacity: 1;
  }
  20%,50% {
    opacity: 0;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-scroll-snap-strictness: proximity;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-content: "";
      --tw-animation-delay: 0s;
      --tw-animation-direction: normal;
      --tw-animation-duration: initial;
      --tw-animation-fill-mode: forwards;
      --tw-animation-iteration-count: 1;
      --tw-enter-opacity: 1;
      --tw-enter-rotate: 0;
      --tw-enter-scale: 1;
      --tw-enter-translate-x: 0;
      --tw-enter-translate-y: 0;
      --tw-exit-opacity: 1;
      --tw-exit-rotate: 0;
      --tw-exit-scale: 1;
      --tw-exit-translate-x: 0;
      --tw-exit-translate-y: 0;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./styles/globals.css","webpack://./node_modules/tw-animate-css/dist/tw-animate.css"],"names":[],"mappings":"AAAA,iEAAA;ACo7BE,iBAAmB;AAp7BrB,yCAAyC;AAEzC;EACE;IACE;;2CAGuC;IAEvC;8BAE0B;IAE1B,wCAAwC;IACxC,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAM1C,2CAA2C;IAC3C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,2CAA2C;IAC3C,6CAA6C;IAI7C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAG5C,6CAA6C;IAC7C,8CAA8C;IAE9C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAgB7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAM7C,+CAA+C;IAC/C,+CAA+C;IAC/C,6CAA6C;IAC7C,+CAA+C;IAC/C,+CAA+C;IAU/C,2CAA2C;IAC3C,0CAA0C;IAC1C,4CAA4C;IAO5C,2CAA2C;IAC3C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAE5C,0CAA0C;IAE1C,2CAA2C;IAS3C,2CAA2C;IAC3C,yCAAyC;IAMzC,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAM5C,8CAA8C;IAE9C,8CAA8C;IAE9C,6CAA6C;IAE7C,8CAA8C;IAkB9C,8CAA8C;IAC9C,8CAA8C;IAC9C,4CAA4C;IAC5C,8CAA8C;IAC9C,8CAA8C;IAE9C,8CAA8C;IAO9C,4CAA4C;IAW5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,0CAA0C;IAC1C,0CAA0C;IAW1C,2CAA2C;IAC3C,2CAA2C;IAM3C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAE7C,2CAA2C;IAC3C,4CAA4C;IAE5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,0CAA0C;IAuF1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IAErB,sBAAsB;IACtB,sBAAsB;IAEtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAS1B,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAI5B,0BAA0B;IAE1B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAExB,qBAAqB;IACrB,qBAAqB;IAErB,wBAAwB;IAGxB,qBAAqB;IAKrB,kBAAkB;IAwClB,2CAA2C;IAE3C,uCAAuC;IAEvC,+DAA+D;IAqC/D,cAAc;IAKd,gBAAgB;IAQhB,sBAAsB;IAEtB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;ICzY3D,6BAA8B;EDpHf;AADJ;AAohBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,8NAcC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EA3BpC;EAoCN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADqB;EAQpC;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAxZnC;AA6ZZ;EACE;IAAA,2BAAmB;IAAnB,2BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,8DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oEAAmB;EAAA;EAAnB;IAAA,qEAAmB;EAAA;EAAnB;IAAA,kEAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,8DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,mOAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,gFAAmB;IAAnB,wFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,oEAAmB;IAAnB,4EAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,gFAAmB;IAAnB,wFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,qEAAmB;IAAnB,6EAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,2CAAmB;IAAnB,wCAAmB;IAAnB,wDAAmB;IAAnB,qEAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;IAAnB,qDAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB;MAAA,iEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,2EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,4EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8EAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,gFAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,gFAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,gFAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,oEAAmB;EAAA;EAAnB;IAAA,sEAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,gFAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,gFAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,mFAAmB;IAAnB;MAAA,gFAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,8EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB;MAAA,8DAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB;MAAA,iEAAmB;IAAA;EAAA;EAAnB;IAAA,qEAAmB;IAAnB;MAAA,iEAAmB;IAAA;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,wIAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,wIAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IEp7ByzL,+BAA6C;IAAE,qBAA+C;EFo7Bp4L;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IEp7B4mM,6BAA0C;IAA0C,qBAA6C;EFo7B1tM;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mEAAmB;EAAA;EAAnB;IAAA,yEAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB;MAAA,gEAAmB;IAAA;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,UAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,UAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,kDAAmB;IAAnB,qDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,2EAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,6EAAmB;MAAA;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,gFAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,gFAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,gFAAmB;MAAA;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA;QAAA,oEAAmB;MAAA;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,gFAAmB;IAAA;IAAnB;MAAA;QAAA,+EAAmB;MAAA;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,6EAAmB;MAAA;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA;QAAA,sEAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,+EAAmB;MAAA;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA;QAAA,+EAAmB;MAAA;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,gFAAmB;IAAA;IAAnB;MAAA;QAAA,4EAAmB;MAAA;IAAA;IAAnB;MAAA,gFAAmB;IAAA;IAAnB;MAAA;QAAA,4EAAmB;MAAA;IAAA;IAAnB;MAAA,gFAAmB;IAAA;IAAnB;MAAA;QAAA,4EAAmB;MAAA;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,gFAAmB;IAAA;IAAnB;MAAA;QAAA,4EAAmB;MAAA;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA;QAAA,wEAAmB;MAAA;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,iFAAmB;IAAA;IAAnB;MAAA;QAAA,8EAAmB;MAAA;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,gFAAmB;IAAA;IAAnB;MAAA;QAAA,+EAAmB;MAAA;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,0CAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,0CAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,4CAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,2CAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,uCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,uCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,uCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,8LAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,wBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,yEAAmB;MAAnB,sIAAmB;IAAA;IAAnB;MAAA,gIAAmB;MAAnB,sIAAmB;IAAA;IAAnB;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;IAAnB;MAAA,kFAAmB;IAAA;IAAnB;MAAA;QAAA,wIAAmB;MAAA;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,0LAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA;QAAA,sEAAmB;MAAA;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,uCAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,8EAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4GAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4GAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB;MAAA,qEAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IEp7B+qR,+CAA6D;EFo7BztR;EAAnB;IEp7B2zQ,kDAAgE;EFo7Bx2Q;EAAnB;IEp7B2kU,8CAA4D;EFo7BpnU;EAAnB;IEp7B8tT,iDAA+D;EFo7B1wT;EAAnB;IAAA,mOAAmB;EAAA;EAAnB;IEp7B+wL,qBAAqB;EFo7BjxL;EAAnB;IAAA,kOAAmB;EAAA;EAAnB;IEp7B26L,oBAAoB;EFo7B56L;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,SAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,WAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kDAAmB;IAAnB,qDAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IEp7B8lP,iDAAgE;EFo7B3oP;EAAnB;IAAA,2CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IEp7B+qR,8CAA6D;EFo7BztR;EAAnB;IAAA,gCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IEp7B2zQ,iDAAgE;EFo7Bx2Q;EAAnB;IAAA,2CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IEp7Bq9P,8CAA6D;EFo7B//P;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mFAAmB;EAAA;EAAnB;IAAA,kOAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IEp7Bq9L,8BAA4C;IAAE,oBAA8C;EFo7B9hM;EAAnB;IEp7Bq9L,+BAA4C;IAAE,qBAA8C;EFo7B9hM;EAAnB;IEp7Bo8M,4BAAyC;IAAyC,oBAA4C;EFo7B/iN;EAAnB;IEp7Bm0S,2BAA2B;EFo7B30S;EAAnB;IEp7BmqT,4BAA4B;EFo7B5qT;EAAnB;IEp7BghU,2BAA2B;EFo7BxhU;EAAnB;IEp7ByoU,mCAAkF;EFo7BxsU;EAAnB;IEp7Bs9R,4BAA4B;EFo7B/9R;EAAnB;IEp7BghS,gDAA+D;EFo7B5jS;EAAnB;IAAA,kOAAmB;EAAA;EAAnB;IEp7Bq9L,8BAA4C;IAAE,oBAA8C;EFo7B9hM;EAAnB;IEp7Bo8M,4BAAyC;IAAyC,oBAA4C;EFo7B/iN;EAAnB;IAAA,kOAAmB;EAAA;EAAnB;IEp7B26L,oBAAoB;EFo7B56L;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qFAAmB;EAAA;EAAnB;IAAA,mOAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB;MAAA,qEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IEp7ByzL,+BAA6C;IAAE,qBAA+C;EFo7Bp4L;EAAnB;IEp7B4mM,6BAA0C;IAA0C,oBAA6C;EFo7B1tM;EAAnB;IEp7B4mM,6BAA0C;IAA0C,qBAA6C;EFo7B1tM;EAAnB;IEp7Bu5P,4BAA4B;EFo7Bh6P;EAAnB;IEp7B8vQ,6BAA6B;EFo7BxwQ;EAAnB;IEp7BknR,4BAA4B;EFo7B3nR;EAAnB;IEp7BkiP,6BAA6B;EFo7B5iP;EAAnB;IEp7B8lP,iDAAgE;EFo7B3oP;EAAnB;IEp7BgqP,qCAAoF;EFo7BjuP;EAAnB;IAAA,mOAAmB;EAAA;EAAnB;IEp7ByzL,+BAA6C;IAAE,qBAA+C;EFo7Bp4L;EAAnB;IEp7B4mM,6BAA0C;IAA0C,qBAA6C;EFo7B1tM;EAAnB;IAAA;MAAA,+BAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mOAAmB;EAAA;EAAnB;IEp7B+wL,qBAAqB;EFo7BjxL;EAAnB;IAAA,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kOAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA;MAAA,SAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,qBAAmB;MAAnB,mBAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MEp7BohQ,oCAAmF;IFo7BplQ;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,kDAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,0HAAmB;MAAnB,sIAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,iDAAmB;IAAA;IAAnB;MAAA,sDAAmB;IAAA;IAAnB;MAAA,+EAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,2DAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;IAAnB;MAAA;QAAA,qEAAmB;MAAA;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA;QAAA,oEAAmB;MAAA;IAAA;IAAnB;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kDAAmB;IAAnB,qDAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA;QAAA,sEAAmB;MAAA;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA;QAAA,wEAAmB;MAAA;IAAA;IAAnB;MAAA,+BAAmB;IAAA;EAAA;AADJ;AEn7BjB;EAA+B,WAAU;EAAC,eAAc;EAAC,iBAAgB;AAA3C;AAA4C;EAAmC,WAAU;EAAC,eAAc;EAAC,qBAAoB;AAA/C;AAAgD;EAAkC,WAAU;EAAC,eAAc;AAA1B;AAA2B;EAAmC,WAAU;EAAC,eAAc;EAAC,uBAAsB;AAAjD;AAAkD;EAAyC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA6B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA4B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA2B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAiC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAiC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA4B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA2B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA0B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAgC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAgC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;ADK/hC;EACE,0BAA2B;EAC3B,8BAA+B;EAC/B,oBAAqB;EACrB,mCAAoC;EACpC,uBAAwB;EACxB,sCAAuC;EACvC,2BAA4B;EAC5B,sCAAuC;EACvC,4BAA6B;EAC7B,wCAAyC;EACzC,wBAAyB;EACzB,oCAAqC;EACrC,yBAA0B;EAC1B,qCAAsC;EACtC,wCAAyC;EACzC,mDAAoD;EACpD,0BAA2B;EAC3B,yBAA0B;EAC1B,wBAAyB;EACzB,oCAAqC;EACrC,mCAAoC;EACpC,oCAAqC;EACrC,oCAAqC;EACrC,mCAAoC;EACpC,kBAAmB;EACnB,2BAA4B;EAC5B,sCAAuC;EACvC,mCAAoC;EACpC,8CAA+C;EAC/C,iCAAkC;EAClC,6CAA8C;EAC9C,kCAAmC;EACnC,gCAAiC;AAClC;AAED;EACE,8BAA+B;EAC/B,8BAA+B;EAC/B,wBAAyB;EACzB,mCAAoC;EACpC,2BAA4B;EAC5B,sCAAuC;EACvC,2BAA4B;EAC5B,sCAAuC;EACvC,6BAA8B;EAC9B,wCAAyC;EACzC,yBAA0B;EAC1B,oCAAqC;EACrC,0BAA2B;EAC3B,qCAAsC;EACtC,wCAAyC;EACzC,mDAAoD;EACpD,0BAA2B;EAC3B,yBAA0B;EAC1B,wBAAyB;EACzB,qCAAsC;EACtC,mCAAoC;EACpC,mCAAoC;EACpC,mCAAoC;EACpC,oCAAqC;EACrC,2BAA4B;EAC5B,sCAAuC;EACvC,6CAA8C;EAC9C,8CAA+C;EAC/C,kCAAmC;EACnC,6CAA8C;EAC9C,kCAAmC;EACnC,gCAAiC;EAGjC,gBAAiB;EACjB,qBAAsB;EACtB,4BAA6B;EAC7B,kBAAmB;EACnB,sBAAuB;EACvB,oBAAqB;EACrB,qBAAsB;EACtB,mBAAoB;EACpB,kBAAmB;EACnB,sBAAuB;EACvB,qBAAsB;EACtB,0BAA2B;EAC3B,mBAAoB;EACpB,mBAAoB;EAIpB,uBAAwB;EACxB,wBAAyB;EACzB,0BAA2B;EAC3B,uBAAwB;EACxB,2BAA4B;EAC5B,8BAA+B;EAC/B,8BAA+B;AAChC;AAyCD;EACE;IACS,2BAAa;IAAC,0BAAe;IAAf;MAAA,gEAAe;IAAA;EACrC;EACD;IACS,mCAAa;IAAC,wBAAe;EACrC;AACF;AAQD;;;EAGE,gBAAiB;EACjB,yBAA0B;EAC1B,qBAAsB;EACtB,4BAA6B;EAC7B,oBAAqB;EACrB,uCAAwC;EACxC,kBAAmB;EACnB,wBAAyB;EACzB,sBAAuB;EACvB,oBAAqB;EACrB,6BAA8B;EAC9B,qBAAsB;EACtB,oBAAqB;EACrB,oCAAqC;EACrC,4CAA6C;AAC9C;AAED;;EAEE,8BAA+B;EAC/B,yBAA0B;EAC1B,wCAAyC;EACzC,sDAAuD;EACvD,uCAAwC;EACxC,iDAAkD;EAClD,0CAA2C;EAC3C,6CAA8C;EAC9C,+CAAgD;EAChD,oCAAqC;EACrC,6BAA8B;EAC9B,sCAAuC;EACvC,uCAAwC;EACxC,mCAAoC;EACpC,+EAAgF;AACjF;AAED;EACE,gBAAiB;AAClB;AAED;;;;;;;;;;EAUE;;;yBAIwB;AACzB;AAED;EACE,iBAAkB;EAClB,wBAAyB;EACzB,qBAAsB;AACvB;AAED;EACE,wBAA8D;EAA9D;IAAA,6DAA8D;EAAA;EAC9D,8BAA+B;EAC/B,qBAAsB;AACvB;AAED;;;EAGE,6BAA8B;EAC9B,kCAAmC;EACnC,qBAAsB;EACtB,4BAA6B;AAC9B;AAED;;EAEE,oCAAqC;EACrC,uCAAwC;EACxC,qBAAsB;AACvB;AAED;EACE,qBAAsB;EACtB,gBAAiB;AAClB;AAED;EACE,2BAA4B;AAC7B;AAED;EACE,yBAA0B;AAC3B;AAED;EACE,mCAAoC;AACrC;AAED;EACE,iCAAkC;EAClC,kCAAmC;EACnC,qBAAsB;AACvB;AAED;EACE,8BAA+B;EAC/B,qCAAsC;EACtC,aAAc;AACf;AAED;;EAEE,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,YAAa;EACb,kCAAmC;EACnC,qBAAsB;EACtB,oCAAqC;AACtC;AAED;;EAEE,8BAA+B;EAC/B,uBAAwB;AACzB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,YAAa;EACb,kCAAmC;EACnC,gCAAiC;EACjC,4BAA6B;AAC9B;AAED;EACE,oCAAqC;EACrC,+CAAgD;EAEhD,kBAAmB;EACnB,oBAAqB;EACrB,gBAAiB;EACjB,mBAAoB;EACpB,YAAa;EACb,kCAAoF;EAApF;IAAA,mFAAoF;EAAA;EACpF,oBAAqB;EACrB,6BAAmE;EAAnE;IAAA,kEAAmE;EAAA;EACnE,2BAA4B;EAC5B,eAAgB;EAChB,wCAAyC;EACzC,mBAAoB;EACpB,iDAAuF;EAAvF;IAAA,sFAAuF;EAAA;AACxF;AAED;EACE,qCAAsC;EACtC,qBAAsB;EACtB,oCAA0E;EAA1E;IAAA,yEAA0E;EAAA;AAC3E;AAED;EACE,qCAAsC;EACtC;oBAEmB;EACnB,aAAc;AACf;AAED;EACE,WAAY;EACZ,2BAA4B;AAC7B;AAED;EACE,iBAAkB;AACnB;AAED;EACE,oDAAqD;EACrD,6BAA8B;EAE9B,mBAAoB;EACpB,sCAAuC;EACvC,kCAAmC;EACnC,gDAAiD;EACjD,wCAAyC;EACzC,gBAAiB;AAClB;AAED;EACE,kCAAmC;EACnC,sCAAuC;AACxC;AAED;EACE,yBAA0B;EAC1B,uBAAwB;EACxB,gBAAiB;AAClB;AAED;EACE,8BAA+B;EAC/B,oCAA0E;EAA1E;IAAA,yEAA0E;EAAA;AAC3E;AAED;EACE,oBAAqB;EACrB,8BAA+B;EAC/B,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,cAAe;EACf,yBAA0B;AAC3B;AAED;EACE,aAAc;AACf;AAED;EACE,eAAgB;AACjB;AAED;EACE,kBAAmB;EACnB,aAAc;EACd,cAAe;EACf,gDAAiD;EACjD,mBAAoB;EACpB,gBAAiB;EACjB,uCAAwC;EACxC,oBAAqB;EACrB,iCAAkC;EAClC,iBAAkB;AACnB;AAED;EACE,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,sCAAuC;EACvC,iCAAkC;EAClC,oBAAqB;EACrB,mCAAoC;EACpC,4CAAkF;EAAlF;IAAA,iFAAkF;EAAA;EAClF,gCAAiC;AAClC;AAED;EACE,2BAA4B;AAC7B;AAED;EACE,kBAAmB;EACnB,UAAW;EACX,yBAA0B;EAC1B,kBAAmB;EACnB,gBAAiB;EACjB,oBAAqB;EACrB,kBAAmB;EACnB,4BAA6B;AAC9B;AAED;;EAEE,gCAAiC;AAClC;AAOD;;;EAGE,gBAAiB;EACjB,oCAAqC;EACrC,2CAA4C;EAC5C,kBAAmB;EACnB,sBAAuB;EACvB,oBAAqB;EACrB,qBAAsB;EACtB,mBAAoB;EACpB,kBAAmB;EACnB,sBAAuB;EACvB,uCAAwC;EACxC,4CAA6C;EAC7C,mBAAoB;EACpB,mBAAoB;EACpB,uBAAwB;EACxB,wBAAyB;EACzB,0BAA2B;EAC3B,uBAAwB;EACxB,2BAA4B;EAC5B,8BAA+B;EAC/B,8BAA+B;AAChC;AAED;;;EAGE,gBAAiB;EACjB,qBAAsB;EACtB,4BAA6B;EAC7B,kBAAmB;EACnB,sBAAuB;EACvB,oBAAqB;EACrB,qBAAsB;EACtB,mBAAoB;EACpB,kBAAmB;EACnB,sBAAuB;EACvB,qBAAsB;EACtB,0BAA2B;EAC3B,mBAAoB;EACpB,mBAAoB;EACpB,uBAAwB;EACxB,wBAAyB;EACzB,0BAA2B;EAC3B,uBAAwB;EACxB,2BAA4B;EAC5B,8BAA+B;EAC/B,8BAA+B;AAChC;AAED;;;EAGE;;;yBAIwB;AACzB;AD4bC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB,eAAmB;AAAA;AAhfjB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AEldspF;EAAmB;IAAO,kCAAkC;IAAE,qMAAqM;EAA3O;AAAP;AAAsP;EAAkB;IAAK,iCAAiC;IAAE,+LAA+L;EAApO;AAAL;AAAqoB;EAA4B;IAAO,SAAS;EAAX;EAAc;IAAK,+JAA+J;EAAjK;AAAxB;AAA6L;EAA0B;IAAO,+JAA+J;EAAjK;EAAoK;IAAK,SAAS;EAAX;AAA9K;AAAyrB;EAAyB;IAAc,UAAU;EAAZ;EAAe;IAAU,UAAU;EAAZ;AAArC;AFo7BpgJ;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,sCAAmB;MAAnB,uBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;MAAnB,gBAAmB;MEp7BrB,wBAA8B;MAA4C,gCAAkC;MAAgD,gCAAiC;MAA2B,kCAAkC;MAAkD,iCAAwC;MAA2C,qBAA4B;MAA2C,oBAA2B;MAA2C,mBAA0B;MAA2C,yBAAgC;MAA2C,yBAAgC;MAA2C,oBAA2B;MAA2C,mBAA0B;MAA2C,kBAAyB;MAA2C,wBAA+B;MAA2C,wBAA+B;IFo7B1gC;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n      \"Noto Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 none);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 none);\n    --color-neutral-100: oklch(97% 0 none);\n    --color-neutral-200: oklch(92.2% 0 none);\n    --color-neutral-300: oklch(87% 0 none);\n    --color-neutral-400: oklch(70.8% 0 none);\n    --color-neutral-500: oklch(55.6% 0 none);\n    --color-neutral-600: oklch(43.9% 0 none);\n    --color-neutral-700: oklch(37.1% 0 none);\n    --color-neutral-800: oklch(26.9% 0 none);\n    --color-neutral-900: oklch(20.5% 0 none);\n    --color-neutral-950: oklch(14.5% 0 none);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 none);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      -apple-system,\n      BlinkMacSystemFont,\n      \"Segoe UI\",\n      Roboto,\n      \"Helvetica Neue\",\n      \"Noto Sans\",\n      Arial,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring:where(:not(iframe)) {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import 'tailwindcss';\n@import 'tw-animate-css';\n\n@custom-variant dark (&:is(.dark *));\n\n:root {\n  --background: oklch(1 0 0);\n  --foreground: oklch(0.145 0 0);\n  --card: oklch(1 0 0);\n  --card-foreground: oklch(0.145 0 0);\n  --popover: oklch(1 0 0);\n  --popover-foreground: oklch(0.145 0 0);\n  --primary: oklch(0.205 0 0);\n  --primary-foreground: oklch(0.985 0 0);\n  --secondary: oklch(0.97 0 0);\n  --secondary-foreground: oklch(0.205 0 0);\n  --muted: oklch(0.97 0 0);\n  --muted-foreground: oklch(0.556 0 0);\n  --accent: oklch(0.97 0 0);\n  --accent-foreground: oklch(0.205 0 0);\n  --destructive: oklch(0.577 0.245 27.325);\n  --destructive-foreground: oklch(0.577 0.245 27.325);\n  --border: oklch(0.922 0 0);\n  --input: oklch(0.922 0 0);\n  --ring: oklch(0.708 0 0);\n  --chart-1: oklch(0.646 0.222 41.116);\n  --chart-2: oklch(0.6 0.118 184.704);\n  --chart-3: oklch(0.398 0.07 227.392);\n  --chart-4: oklch(0.828 0.189 84.429);\n  --chart-5: oklch(0.769 0.188 70.08);\n  --radius: 0.625rem;\n  --sidebar: oklch(0.985 0 0);\n  --sidebar-foreground: oklch(0.145 0 0);\n  --sidebar-primary: oklch(0.205 0 0);\n  --sidebar-primary-foreground: oklch(0.985 0 0);\n  --sidebar-accent: oklch(0.97 0 0);\n  --sidebar-accent-foreground: oklch(0.205 0 0);\n  --sidebar-border: oklch(0.922 0 0);\n  --sidebar-ring: oklch(0.708 0 0);\n}\n\n.dark {\n  --background: oklch(0.145 0 0);\n  --foreground: oklch(0.985 0 0);\n  --card: oklch(0.145 0 0);\n  --card-foreground: oklch(0.985 0 0);\n  --popover: oklch(0.145 0 0);\n  --popover-foreground: oklch(0.985 0 0);\n  --primary: oklch(0.985 0 0);\n  --primary-foreground: oklch(0.205 0 0);\n  --secondary: oklch(0.269 0 0);\n  --secondary-foreground: oklch(0.985 0 0);\n  --muted: oklch(0.269 0 0);\n  --muted-foreground: oklch(0.708 0 0);\n  --accent: oklch(0.269 0 0);\n  --accent-foreground: oklch(0.985 0 0);\n  --destructive: oklch(0.396 0.141 25.723);\n  --destructive-foreground: oklch(0.637 0.237 25.331);\n  --border: oklch(0.269 0 0);\n  --input: oklch(0.269 0 0);\n  --ring: oklch(0.439 0 0);\n  --chart-1: oklch(0.488 0.243 264.376);\n  --chart-2: oklch(0.696 0.17 162.48);\n  --chart-3: oklch(0.769 0.188 70.08);\n  --chart-4: oklch(0.627 0.265 303.9);\n  --chart-5: oklch(0.645 0.246 16.439);\n  --sidebar: oklch(0.205 0 0);\n  --sidebar-foreground: oklch(0.985 0 0);\n  --sidebar-primary: oklch(0.488 0.243 264.376);\n  --sidebar-primary-foreground: oklch(0.985 0 0);\n  --sidebar-accent: oklch(0.269 0 0);\n  --sidebar-accent-foreground: oklch(0.985 0 0);\n  --sidebar-border: oklch(0.269 0 0);\n  --sidebar-ring: oklch(0.439 0 0);\n\n  /* Mission Control palette — GitHub HQ wallboard aesthetic */\n  --mc-bg: #06090e;\n  --mc-surface: #0e1319;\n  --mc-surface-raised: #131a22;\n  --mc-cyan: #1de0c5;\n  --mc-cyan-dim: #0e9a87;\n  --mc-purple: #b855e7;\n  --mc-magenta: #f47aa5;\n  --mc-white: #e0e5ed;\n  --mc-gray: #6a7485;\n  --mc-gray-dim: #424a57;\n  --mc-divider: #1e2735;\n  --mc-divider-soft: #141a24;\n  --mc-green: #5fd692;\n  --mc-amber: #f59e0b;\n\n  /* Text color roles — mapped from reference wallboard image.\n     Use these tokens (not raw grays) so text categories stay consistent. */\n  --mc-text-hero: #edf0f5;         /* big hero numbers, e.g. \"1,278\", \"375\" */\n  --mc-text-label: #c8d0da;        /* section / panel labels, e.g. \"Forked Projects\", \"Data Stream\" */\n  --mc-text-primary: #d8dde5;      /* primary content, e.g. developer names, booking titles */\n  --mc-text-meta: #6a7485;         /* secondary captions, e.g. \"Last 10 min\", \"react-select\" */\n  --mc-text-meta-dim: #424a57;     /* tertiary, e.g. axis labels (1-5), SHA fragments */\n  --mc-text-accent-teal: #1de0c5;  /* primary data emphasis, e.g. \"CreateEvent\", \"Added\" */\n  --mc-text-accent-pink: #f47aa5;  /* secondary data emphasis, e.g. \"to/from\", \"Deleted\" */\n}\n\n@theme inline {\n  --color-background: var(--background);\n  --color-foreground: var(--foreground);\n  --color-card: var(--card);\n  --color-card-foreground: var(--card-foreground);\n  --color-popover: var(--popover);\n  --color-popover-foreground: var(--popover-foreground);\n  --color-primary: var(--primary);\n  --color-primary-foreground: var(--primary-foreground);\n  --color-secondary: var(--secondary);\n  --color-secondary-foreground: var(--secondary-foreground);\n  --color-muted: var(--muted);\n  --color-muted-foreground: var(--muted-foreground);\n  --color-accent: var(--accent);\n  --color-accent-foreground: var(--accent-foreground);\n  --color-destructive: var(--destructive);\n  --color-destructive-foreground: var(--destructive-foreground);\n  --color-border: var(--border);\n  --color-input: var(--input);\n  --color-ring: var(--ring);\n  --color-chart-1: var(--chart-1);\n  --color-chart-2: var(--chart-2);\n  --color-chart-3: var(--chart-3);\n  --color-chart-4: var(--chart-4);\n  --color-chart-5: var(--chart-5);\n  --radius-sm: calc(var(--radius) - 4px);\n  --radius-md: calc(var(--radius) - 2px);\n  --radius-lg: var(--radius);\n  --radius-xl: calc(var(--radius) + 4px);\n  --color-sidebar: var(--sidebar);\n  --color-sidebar-foreground: var(--sidebar-foreground);\n  --color-sidebar-primary: var(--sidebar-primary);\n  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);\n  --color-sidebar-accent: var(--sidebar-accent);\n  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);\n  --color-sidebar-border: var(--sidebar-border);\n  --color-sidebar-ring: var(--sidebar-ring);\n}\n\n@layer base {\n  * {\n    @apply border-border outline-ring/50;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n\n/*\n * Incremental UI theme migration primitives.\n *\n * Use these `kg-*` classes on pages as they migrate so the staff/admin switch\n * can swap visual tokens without maintaining two component trees.\n */\n:root,\n:root[data-ui-theme='classic'],\n[data-ui-theme='classic'] {\n  --kg-bg: #0f172a;\n  --kg-bg-elevated: #111827;\n  --kg-surface: #1e293b;\n  --kg-surface-raised: #334155;\n  --kg-border: #334155;\n  --kg-border-soft: rgba(51, 65, 85, 0.7);\n  --kg-text: #f8fafc;\n  --kg-text-muted: #cbd5e1;\n  --kg-text-dim: #94a3b8;\n  --kg-accent: #f59e0b;\n  --kg-accent-contrast: #0f172a;\n  --kg-success: #34d399;\n  --kg-danger: #f87171;\n  --kg-focus: rgba(245, 158, 11, 0.45);\n  --kg-shadow: 0 16px 44px rgba(0, 0, 0, 0.32);\n}\n\n:root[data-ui-theme='mission-control'],\n[data-ui-theme='mission-control'] {\n  --kg-bg: var(--mc-bg, #06090e);\n  --kg-bg-elevated: #080c16;\n  --kg-surface: var(--mc-surface, #0e1319);\n  --kg-surface-raised: var(--mc-surface-raised, #131a22);\n  --kg-border: var(--mc-divider, #1e2735);\n  --kg-border-soft: var(--mc-divider-soft, #141a24);\n  --kg-text: var(--mc-text-primary, #d8dde5);\n  --kg-text-muted: var(--mc-text-meta, #6a7485);\n  --kg-text-dim: var(--mc-text-meta-dim, #424a57);\n  --kg-accent: var(--mc-cyan, #1de0c5);\n  --kg-accent-contrast: #06110f;\n  --kg-success: var(--mc-green, #5fd692);\n  --kg-danger: var(--mc-magenta, #f47aa5);\n  --kg-focus: rgba(29, 224, 197, 0.4);\n  --kg-shadow: 0 18px 54px rgba(0, 0, 0, 0.46), 0 0 28px rgba(29, 224, 197, 0.08);\n}\n\n.kg-theme-root {\n  min-height: 100%;\n}\n\n.kg-theme-transition,\n.kg-page,\n.kg-app-header,\n.kg-panel,\n.kg-dialog,\n.kg-popover,\n.kg-row,\n.kg-input,\n.kg-button,\n.kg-theme-toggle {\n  transition:\n    background-color 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease,\n    box-shadow 160ms ease;\n}\n\n.kg-page {\n  min-height: 100vh;\n  background: var(--kg-bg);\n  color: var(--kg-text);\n}\n\n.kg-app-header {\n  background: color-mix(in srgb, var(--kg-bg) 88%, transparent);\n  border-color: var(--kg-border);\n  color: var(--kg-text);\n}\n\n.kg-panel,\n.kg-dialog,\n.kg-popover {\n  background: var(--kg-surface);\n  border: 1px solid var(--kg-border);\n  color: var(--kg-text);\n  box-shadow: var(--kg-shadow);\n}\n\n.kg-panel-raised,\n.kg-row {\n  background: var(--kg-surface-raised);\n  border: 1px solid var(--kg-border-soft);\n  color: var(--kg-text);\n}\n\n.kg-title {\n  color: var(--kg-text);\n  font-weight: 600;\n}\n\n.kg-meta {\n  color: var(--kg-text-muted);\n}\n\n.kg-meta-dim {\n  color: var(--kg-text-dim);\n}\n\n.kg-divider {\n  border-color: var(--kg-border-soft);\n}\n\n.kg-input {\n  background: var(--kg-bg-elevated);\n  border: 1px solid var(--kg-border);\n  color: var(--kg-text);\n}\n\n.kg-input:focus {\n  border-color: var(--kg-accent);\n  box-shadow: 0 0 0 1px var(--kg-focus);\n  outline: none;\n}\n\n.kg-button,\n.kg-button-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  border: 1px solid var(--kg-border);\n  color: var(--kg-text);\n  background: var(--kg-surface-raised);\n}\n\n.kg-button:hover,\n.kg-button-secondary:hover {\n  border-color: var(--kg-accent);\n  color: var(--kg-accent);\n}\n\n.kg-button-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  border: 1px solid var(--kg-accent);\n  color: var(--kg-accent-contrast);\n  background: var(--kg-accent);\n}\n\n.kg-theme-toggle {\n  --kg-toggle-accent: var(--kg-accent);\n  --kg-toggle-contrast: var(--kg-accent-contrast);\n\n  position: relative;\n  display: inline-flex;\n  min-height: 2rem;\n  align-items: center;\n  gap: 0.45rem;\n  border: 1px solid color-mix(in srgb, var(--kg-border) 70%, var(--kg-toggle-accent));\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--kg-surface) 82%, transparent);\n  color: var(--kg-text-muted);\n  cursor: pointer;\n  padding: 0.18rem 0.22rem 0.18rem 0.55rem;\n  white-space: nowrap;\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--kg-border-soft) 50%, transparent);\n}\n\n.kg-theme-toggle:hover {\n  border-color: var(--kg-toggle-accent);\n  color: var(--kg-text);\n  background: color-mix(in srgb, var(--kg-surface-raised) 88%, transparent);\n}\n\n.kg-theme-toggle:focus-visible {\n  border-color: var(--kg-toggle-accent);\n  box-shadow:\n    0 0 0 2px var(--kg-focus),\n    var(--kg-shadow);\n  outline: none;\n}\n\n.kg-theme-toggle--full {\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.kg-theme-toggle--full .kg-theme-toggle__track {\n  margin-left: auto;\n}\n\n.kg-theme-toggle--mc {\n  --kg-toggle-accent: var(--mc-cyan, var(--kg-accent));\n  --kg-toggle-contrast: #06110f;\n\n  min-height: 1.75rem;\n  border-color: rgba(29, 224, 197, 0.28);\n  background: rgba(14, 19, 25, 0.72);\n  color: var(--mc-text-meta, var(--kg-text-muted));\n  padding: 0.12rem 0.18rem 0.12rem 0.42rem;\n  box-shadow: none;\n}\n\n.kg-theme-toggle--mc:hover {\n  background: rgba(19, 26, 34, 0.86);\n  color: var(--mc-white, var(--kg-text));\n}\n\n.kg-theme-toggle--ghost {\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n\n.kg-theme-toggle--ghost:hover {\n  border-color: var(--kg-border);\n  background: color-mix(in srgb, var(--kg-surface-raised) 64%, transparent);\n}\n\n.kg-theme-toggle__icon {\n  display: inline-flex;\n  color: var(--kg-toggle-accent);\n  flex: 0 0 auto;\n}\n\n.kg-theme-toggle__title {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.kg-theme-toggle--mc .kg-theme-toggle__title {\n  display: none;\n}\n\n.kg-theme-toggle--mc.kg-theme-toggle--full .kg-theme-toggle__title {\n  display: inline;\n}\n\n.kg-theme-toggle__track {\n  position: relative;\n  display: grid;\n  width: 6.25rem;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: center;\n  overflow: hidden;\n  border: 1px solid var(--kg-border-soft);\n  border-radius: 999px;\n  background: var(--kg-bg-elevated);\n  padding: 0.125rem;\n}\n\n.kg-theme-toggle--mc .kg-theme-toggle__track {\n  width: 5.75rem;\n}\n\n.kg-theme-toggle__thumb {\n  position: absolute;\n  inset: 0.125rem auto 0.125rem 0.125rem;\n  width: calc((100% - 0.25rem) / 2);\n  border-radius: 999px;\n  background: var(--kg-toggle-accent);\n  box-shadow: 0 0 14px color-mix(in srgb, var(--kg-toggle-accent) 34%, transparent);\n  transition: transform 180ms ease;\n}\n\n.kg-theme-toggle[aria-pressed='true'] .kg-theme-toggle__thumb {\n  transform: translateX(100%);\n}\n\n.kg-theme-toggle__option {\n  position: relative;\n  z-index: 1;\n  color: var(--kg-text-dim);\n  font-size: 0.63rem;\n  font-weight: 650;\n  line-height: 1.35rem;\n  text-align: center;\n  transition: color 180ms ease;\n}\n\n.kg-theme-toggle:not([aria-pressed='true']) .kg-theme-toggle__option--old,\n.kg-theme-toggle[aria-pressed='true'] .kg-theme-toggle__option--new {\n  color: var(--kg-toggle-contrast);\n}\n\n/*\n * Mission Control surfaces and portaled dialogs still use `mc-*` tokens\n * directly. Keep these tokens on the active theme root as well as `.mc-root`\n * so Radix portals inherit the same palette as the page that opened them.\n */\n:root[data-ui-theme='classic'],\n[data-ui-theme='classic'],\n[data-ui-theme='classic'] .mc-root {\n  --mc-bg: #0f172a;\n  --mc-surface: rgba(30, 41, 59, 0.82);\n  --mc-surface-raised: rgba(51, 65, 85, 0.72);\n  --mc-cyan: #f59e0b;\n  --mc-cyan-dim: #d97706;\n  --mc-purple: #a78bfa;\n  --mc-magenta: #fb7185;\n  --mc-white: #f8fafc;\n  --mc-gray: #cbd5e1;\n  --mc-gray-dim: #94a3b8;\n  --mc-divider: rgba(148, 163, 184, 0.28);\n  --mc-divider-soft: rgba(148, 163, 184, 0.16);\n  --mc-green: #34d399;\n  --mc-amber: #f59e0b;\n  --mc-text-hero: #f8fafc;\n  --mc-text-label: #fde68a;\n  --mc-text-primary: #e2e8f0;\n  --mc-text-meta: #cbd5e1;\n  --mc-text-meta-dim: #94a3b8;\n  --mc-text-accent-teal: #f59e0b;\n  --mc-text-accent-pink: #fb7185;\n}\n\n:root[data-ui-theme='mission-control'],\n[data-ui-theme='mission-control'],\n[data-ui-theme='mission-control'] .mc-root {\n  --mc-bg: #06090e;\n  --mc-surface: #0e1319;\n  --mc-surface-raised: #131a22;\n  --mc-cyan: #1de0c5;\n  --mc-cyan-dim: #0e9a87;\n  --mc-purple: #b855e7;\n  --mc-magenta: #f47aa5;\n  --mc-white: #e0e5ed;\n  --mc-gray: #6a7485;\n  --mc-gray-dim: #424a57;\n  --mc-divider: #1e2735;\n  --mc-divider-soft: #141a24;\n  --mc-green: #5fd692;\n  --mc-amber: #f59e0b;\n  --mc-text-hero: #edf0f5;\n  --mc-text-label: #c8d0da;\n  --mc-text-primary: #d8dde5;\n  --mc-text-meta: #6a7485;\n  --mc-text-meta-dim: #424a57;\n  --mc-text-accent-teal: #1de0c5;\n  --mc-text-accent-pink: #f47aa5;\n}\n\n.kg-theme-root .mc-root,\n.kg-theme-root .mc-panel,\n.kg-theme-root .mc-row {\n  transition:\n    background-color 180ms ease,\n    border-color 180ms ease,\n    color 180ms ease,\n    box-shadow 180ms ease;\n}\n","@property --tw-animation-delay{syntax:\"*\";inherits:false;initial-value:0s}@property --tw-animation-direction{syntax:\"*\";inherits:false;initial-value:normal}@property --tw-animation-duration{syntax:\"*\";inherits:false}@property --tw-animation-fill-mode{syntax:\"*\";inherits:false;initial-value:forwards}@property --tw-animation-iteration-count{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-opacity{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-rotate{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-scale{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-translate-y{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-opacity{syntax:\"*\";inherits:false;initial-value:1}@property --tw-exit-rotate{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-scale{syntax:\"*\";inherits:false;initial-value:1}@property --tw-exit-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-translate-y{syntax:\"*\";inherits:false;initial-value:0}@theme inline{--animation-delay-0: 0s; --animation-delay-75: 75ms; --animation-delay-100: .1s; --animation-delay-150: .15s; --animation-delay-200: .2s; --animation-delay-300: .3s; --animation-delay-500: .5s; --animation-delay-700: .7s; --animation-delay-1000: 1s; --animation-repeat-0: 0; --animation-repeat-1: 1; --animation-repeat-infinite: infinite; --animation-direction-normal: normal; --animation-direction-reverse: reverse; --animation-direction-alternate: alternate; --animation-direction-alternate-reverse: alternate-reverse; --animation-fill-mode-none: none; --animation-fill-mode-forwards: forwards; --animation-fill-mode-backwards: backwards; --animation-fill-mode-both: both; --percentage-0: 0; --percentage-5: .05; --percentage-10: .1; --percentage-15: .15; --percentage-20: .2; --percentage-25: .25; --percentage-30: .3; --percentage-35: .35; --percentage-40: .4; --percentage-45: .45; --percentage-50: .5; --percentage-55: .55; --percentage-60: .6; --percentage-65: .65; --percentage-70: .7; --percentage-75: .75; --percentage-80: .8; --percentage-85: .85; --percentage-90: .9; --percentage-95: .95; --percentage-100: 1; --percentage-translate-full: 1; --animate-in: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards); --animate-out: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,forwards); @keyframes enter { from { opacity: var(--tw-enter-opacity,1); transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0)); }}@keyframes exit { to { opacity: var(--tw-exit-opacity,1); transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0)); }}--animate-accordion-down: accordion-down var(--tw-animation-duration,var(--tw-duration,.2s))ease-out; --animate-accordion-up: accordion-up var(--tw-animation-duration,var(--tw-duration,.2s))ease-out; --animate-collapsible-down: collapsible-down var(--tw-animation-duration,var(--tw-duration,.2s))ease-out; --animate-collapsible-up: collapsible-up var(--tw-animation-duration,var(--tw-duration,.2s))ease-out; @keyframes accordion-down { from { height: 0; }to { height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,auto)))); }}@keyframes accordion-up { from { height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,auto)))); }to { height: 0; }}@keyframes collapsible-down { from { height: 0; }to { height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto)))); }}@keyframes collapsible-up { from { height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto)))); }to { height: 0; }}--animate-caret-blink: caret-blink 1.25s ease-out infinite; @keyframes caret-blink { 0%,70%,100% { opacity: 1; }20%,50% { opacity: 0; }}}@utility animation-duration-*{--tw-animation-duration: calc(--value(number)*1ms); --tw-animation-duration: --value(--animation-duration-*,[duration],\"initial\",[*]); animation-duration: calc(--value(number)*1ms); animation-duration: --value(--animation-duration-*,[duration],\"initial\",[*]);}@utility delay-*{animation-delay: calc(--value(number)*1ms); animation-delay: --value(--animation-delay-*,[duration],\"initial\",[*]); --tw-animation-delay: calc(--value(number)*1ms); --tw-animation-delay: --value(--animation-delay-*,[duration],\"initial\",[*]);}@utility repeat-*{animation-iteration-count: --value(--animation-repeat-*,number,\"initial\",[*]); --tw-animation-iteration-count: --value(--animation-repeat-*,number,\"initial\",[*]);}@utility direction-*{animation-direction: --value(--animation-direction-*,\"initial\",[*]); --tw-animation-direction: --value(--animation-direction-*,\"initial\",[*]);}@utility fill-mode-*{animation-fill-mode: --value(--animation-fill-mode-*,\"initial\",[*]); --tw-animation-fill-mode: --value(--animation-fill-mode-*,\"initial\",[*]);}@utility running{animation-play-state: running;}@utility paused{animation-play-state: paused;}@utility play-state-*{animation-play-state: --value(\"initial\",[*]);}@utility fade-in{--tw-enter-opacity: 0;}@utility fade-in-*{--tw-enter-opacity: calc(--value(number)/100); --tw-enter-opacity: --value(--percentage-*,[*]);}@utility fade-out{--tw-exit-opacity: 0;}@utility fade-out-*{--tw-exit-opacity: calc(--value(number)/100); --tw-exit-opacity: --value(--percentage-*,[*]);}@utility zoom-in{--tw-enter-scale: 0;}@utility zoom-in-*{--tw-enter-scale: calc(--value(number)*1%); --tw-enter-scale: calc(--value(ratio)); --tw-enter-scale: --value(--percentage-*,[*]);}@utility -zoom-in-*{--tw-enter-scale: calc(--value(number)*-1%); --tw-enter-scale: calc(--value(ratio)*-1); --tw-enter-scale: --value(--percentage-*,[*]);}@utility zoom-out{--tw-exit-scale: 0;}@utility zoom-out-*{--tw-exit-scale: calc(--value(number)*1%); --tw-exit-scale: calc(--value(ratio)); --tw-exit-scale: --value(--percentage-*,[*]);}@utility -zoom-out-*{--tw-exit-scale: calc(--value(number)*-1%); --tw-exit-scale: calc(--value(ratio)*-1); --tw-exit-scale: --value(--percentage-*,[*]);}@utility spin-in{--tw-enter-rotate: 30deg;}@utility spin-in-*{--tw-enter-rotate: calc(--value(number)*1deg); --tw-enter-rotate: calc(--value(ratio)*360deg); --tw-enter-rotate: --value(--rotate-*,[*]);}@utility -spin-in{--tw-enter-rotate: -30deg;}@utility -spin-in-*{--tw-enter-rotate: calc(--value(number)*-1deg); --tw-enter-rotate: calc(--value(ratio)*-360deg); --tw-enter-rotate: --value(--rotate-*,[*]);}@utility spin-out{--tw-exit-rotate: 30deg;}@utility spin-out-*{--tw-exit-rotate: calc(--value(number)*1deg); --tw-exit-rotate: calc(--value(ratio)*360deg); --tw-exit-rotate: --value(--rotate-*,[*]);}@utility -spin-out{--tw-exit-rotate: -30deg;}@utility -spin-out-*{--tw-exit-rotate: calc(--value(number)*-1deg); --tw-exit-rotate: calc(--value(ratio)*-360deg); --tw-exit-rotate: --value(--rotate-*,[*]);}@utility slide-in-from-top{--tw-enter-translate-y: -100%;}@utility slide-in-from-top-*{--tw-enter-translate-y: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-y: calc(--value(ratio)*-100%); --tw-enter-translate-y: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-in-from-bottom{--tw-enter-translate-y: 100%;}@utility slide-in-from-bottom-*{--tw-enter-translate-y: calc(--value(integer)*var(--spacing)); --tw-enter-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-y: calc(--value(ratio)*100%); --tw-enter-translate-y: --value(--translate-*,[percentage],[length]);}@utility slide-in-from-left{--tw-enter-translate-x: -100%;}@utility slide-in-from-left-*{--tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-in-from-right{--tw-enter-translate-x: 100%;}@utility slide-in-from-right-*{--tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]);}@utility slide-out-to-top{--tw-exit-translate-y: -100%;}@utility slide-out-to-top-*{--tw-exit-translate-y: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-y: calc(--value(ratio)*100%); --tw-exit-translate-y: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-out-to-bottom{--tw-exit-translate-y: 100%;}@utility slide-out-to-bottom-*{--tw-exit-translate-y: calc(--value(integer)*var(--spacing)); --tw-exit-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-y: calc(--value(ratio)*100%); --tw-exit-translate-y: --value(--translate-*,[percentage],[length]);}@utility slide-out-to-left{--tw-exit-translate-x: -100%;}@utility slide-out-to-left-*{--tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-out-to-right{--tw-exit-translate-x: 100%;}@utility slide-out-to-right-*{--tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]);}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
